import React, { useState, useEffect, useRef, useCallback } from "react";
import CustomCardSlider from "../../Components/CardSlider/card-slider";
import "swiper/css";
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../Utils/toastContext";
import { useSelector } from "react-redux";
import MultiLineChart from "../../Components/MultilineChart/multiline-chart";
import {
  PieChart,
  Legend,
  Pie,
  Cell,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Line } from "react-chartjs-2";
import InvestmentList from "../../Pages/My-Investments/investment-list";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { debounce } from "lodash";
import { format, parse } from "date-fns";
import OTPInputWithTimer from "../../Components/OTPInput/otpInputField";
import TooltipCustom from "../../Components/CustomToolTip/tooltip";
import ReinvestProgressCard from "../../Components/progress-bar/progress-bar";
import { svgLogoBase64, currentAppUrl } from "../../Constants/config";
import { useRoutingNumberValidation } from "../../Components/bank-validations/use-routing-number-validation";

Chart.register(CategoryScale, LinearScale, PointElement, LineElement);

const DashboardDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);
  const chartRef = useRef(null); // Reference for the chart container
  const userId = useSelector((state) => state.user.userId);
  const [chartInstance, setChartInstance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);
  const inputRef = useRef(null);
  const [isLoadingCard, setIsLoadingCard] = useState(false);
  const [selectedFilterTransaction, setSelectedFilterTransaction] =
    useState("All");
  const [isOpenOTP, setIsOpenOTP] = useState(false);
  const [isOpenOTPEmail, setIsOpenOTPEmail] = useState(false);
  const inputRefAccountFeeBuffer = useRef(null);
  const [isFocusedAccountFee, setIsFocusedAccountFee] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpenAddMandate, setIsOpenAddMandate] = useState(false);
  const [isOpenProcessPayment, setIsOpenProcessPayment] = useState(false);
  const [isMandateAvailable, setIsMandateAvailable] = useState(false);
  const [isFocusedFinal, setIsFocusedFinal] = useState(false);
  const [isClientPopupOpen, setIsClientPopupOpen] = useState(null);
  const [payId, setPayId] = useState("");

  const [cardDatanew, setcardData] = useState([]);
  const [investmentList, setInvestmentList] = useState([]);
  const [transactionTypeValue, setTransactionTypeValue] = useState("debit");
  const [transactionTypeName, setTransactionTypeName] = useState("Withdraw");
  const [transactionAmount, setTransactionAmount] = useState(0);
  const [transactionAmountPayID, setTransactionAmountPayID] = useState(0);

  const [transactionTypeValueSecond, setTransactionTypeValueSecond] =
    useState("rtgs");
  const [transactionTypeNameSecond, setTransactionTypeNameSecond] =
    useState("rtgs");
  const getCurrentDate = () => {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset()); // Adjust for timezone
    return today.toISOString().split("T")[0]; // Get YYYY-MM-DD format
  };
  const [creationDate, setCreationDate] = useState(getCurrentDate());
  const [recStartDate, setRecStartDate] = useState("");
  const [recEndDate, setRecEndDate] = useState("");
  const [defaultCard, setDefaultCard] = useState({});
  const searchParams = new URLSearchParams(location.search);
  const cardId = searchParams.get("cardId");
  const [cashAccountId, setCashAccountId] = useState(null);
  const accountRef = useRef();
  const [customTime, setCustomTime] = useState(24);
  const [selectedChart, setSelectedChart] = useState(null);
  const [tooltipDataPerf, setTooltipDataPerf] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedStockIndex, setSelectedStockIndex] = useState(null);
  const [selectedIndices, setSelectedIndices] = useState({});
  const [transactionTableData, setTransactionTableData] = useState([]);
  const [recentActivityData, setRecentActivityData] = useState([]);
  const [swiftCode, setSwiftCode] = useState("");
  const [swiftError, setSwiftError] = useState("");

  const [transitNumber, setTransitNumber] = useState("");
  const [iban, setIban] = useState("");
  const [bufferAmount, setBufferAmount] = useState(0);
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [newAccountName, setNewAccountName] = useState("");
  const [userPayId, setUserPayID] = useState("");

  const [mandateTable, setMandateTable] = useState([]);

  const [isFocusedAccountFeeBuffer, setIsFocusedFeeBuffer] = useState(false);
  const { routingNumber, routingError, handleRoutingChange, setRoutingNumber } =
    useRoutingNumberValidation();
  const europeanCountryCodes = new Set([
    "AL",
    "AD",
    "AM",
    "AT",
    "AZ",
    "BY",
    "BE",
    "BA",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "GE",
    "DE",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "KZ",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "MD",
    "MC",
    "ME",
    "NL",
    "MK",
    "NO",
    "PL",
    "PT",
    "RO",
    "RU",
    "SM",
    "RS",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "TR",
    "UA",
    "GB",
    "VA",
  ]);
  const [isModalOpenAccountEdit, setIsModalOpenAccountEdit] = useState(false);
  const [acccountName, setAccountName] = useState("");
  const [currentAccount, setcurrentAccount] = useState({});
  const [isOpenAccount, setisOpenAccount] = useState(false);
  const [customerAccountId, setCustomerAccountId] = useState(null);
  const [RTGSAllowed, setRTGSAllowed] = useState(true);
  const [totalPagesMandate, setTotalPagesMandate] = useState(0);
  const [isStatusOpenMandate, setIsStatusOpenMandate] = useState(false);
  const StatusRef = useRef();
  const [finalConvertedAmount, setFinalConvertedAmount] = useState(0);
  const inputRefFinal = useRef(null);
  const inputRefPayID = useRef(null);
  const [finalConvertedRate, setFinalConvertedRate] = useState(0);
  const [lastEdited, setLastEdited] = useState("transaction"); // "transaction" | "final"
  const [usdRateCashAccountTo, setUsdRateCashAccountTo] = useState("");
  const [usdRateCashAccount, setUsdRateCashAccount] = useState("");
  const [copied, setCopied] = useState(false);
  const validateSwift = (value) => {
    const swiftRegex =
      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    return swiftRegex.test(value);
  };
  const handleSwiftChange = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCode(value);

    if (value && !validateSwift(value)) {
      setSwiftError("Invalid SWIFT/BIC format");
    } else {
      setSwiftError("");
    }
  };
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      showToast("Pay ID copied!", "success");
      setTimeout(() => setCopied(false), 2000); // reset after 2 sec
    });
  };
  const handleChangeAmountFinal = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setFinalConvertedAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setLastEdited("final");
      setTimeout(() => {
        if (inputRefFinal.current) {
          inputRefFinal.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const handleChangeAmountPayID = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setTransactionAmountPayID(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefPayID.current) {
          inputRefPayID.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  // Step 2: Function to check if a code is European
  function isEuropeanCountry(code) {
    return europeanCountryCodes.has(code.toUpperCase());
  }
  const [cashAccountData, setCashAccountData] = useState([]);
  const [totalInvestedAmount, setTotalInvestedAmount] = useState(0);
  const [totalPerformance, setTotalPerformance] = useState(0);
  const [performanceGraph, setPerformanceGraph] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [totalCount, settotalCount] = useState(0);
  const [totalDividend, setTotalDividend] = useState(0);
  const [totalThreshold, setTotalThreshold] = useState(0);
  const [totalCountMandate, setTotalCountMandate] = useState(0);
  const [expandedRow, setExpandedRow] = useState(null);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [searchAccount, setSearchAccount] = useState("");
  const [AllAccount, setAllAccounts] = useState([]);
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const [selectedDates, setSelectedDates] = useState([]);
  const [quickFilter, setQuickFilter] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const DateCalendarRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");
  const [usdrate, setUsdrate] = useState("");
  const [accountDescription, setAccountDescription] = useState("");
  const [accountCurrency, setAccountCurrency] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [preselectedcashAccount, setpreselectedcashAccount] = useState({});
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: "AU",
    label: "Australia",
  });
  const [preselectedBankType, setpreselectedBankType] = useState({
    value: 1,
    label: "External Bank",
  });
  const [cashAccountForPopup, setCashAccountForPopup] = useState([]);
  const [bankAccountData, setBankAccountData] = useState([]);
  const [thirdPartyBankAccountData, setThirdPartyBankAccountData] = useState(
    []
  );

  const [preselectedTransactionType, setPreselectedTransactionType] = useState({
    value: "debit",
    label: "Withdraw",
  });
  const [preselectedRecurringType, setPreselectedRecurringType] = useState({
    value: "never",
    label: "Never",
  });
  const [selectedAccountBank, setSelectedAccountBank] = useState("");
  const [isCheckedSecond, setIsCheckedSecond] = useState(false);
  const [error, setError] = useState("");

  const [
    preselectedTransactionTypeSecond,
    setPreselectedTransactionTypeSecond,
  ] = useState({ value: "rtgs", label: "RTGS" });
  const [currencyId, setCurrencyId] = useState(null);
  const [transactionStatus, setTransactionStatus] = useState("");
  const [rawData, setrawData] = useState([]);
  const [nabFees, setNabFees] = useState("$12");
  const [nabTime, setNabTime] = useState("");
  const [bsb, setBsb] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [toBsb, setToBsb] = useState("");
  const [bsbError, setBsbError] = useState("");
  const [toAccountName, setToAccountName] = useState("");
  const [toCurrency, setToCurrency] = useState(2);
  const [toBank, setToBank] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [otp, setOtp] = useState("");
  const [otpEmail, setOtpEmail] = useState("");
  const [accountBalance, setAccountBalance] = useState("");
  const [totalInvestedInBreakdown, setTotalInvestedInBreakdown] = useState(0);
  const [breakdown, setBreakdown] = useState([]);
  const [gainers, setGainers] = useState([]);
  const [losers, setLosers] = useState([]);
  const [highlightData, setHighlightData] = useState([]);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine3, setAddressLine3] = useState("");
  const [countryCode, setCountryCode] = useState("AU");
  const [comments, setComments] = useState("");
  const [commentsPayID, setCommentsPayID] = useState("");
  const [transitError, setTransitError] = useState("");

  const [sessionId, setSessionId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("test@gmail.com");
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedPayID, setIsFocusedPayID] = useState(false);

  const [summaryDetails, setSummaryDetails] = useState(false);
  const [summaryDetailsPayID, setSummaryDetailsPayID] = useState(false);

  const [isReinvestAllowed, setIsReinvestAllowed] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const DownloadRef = useRef();
  const [isOpenDownloadReport, setIsOpenDownloadReport] = useState(false);
  const [selected, setSelected] = useState("Download Report");
  const [pdfData, setPdfData] = useState([]);
  const [isHiddenTable, setIsHiddenTable] = useState(false); // Initially hidden
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const [recurringTypeValue, setRecurringTypeValue] = useState("never");
  const [recurringTypeLabel, setRecurringTypeLabel] = useState("Never");
  const DownloadAccountRef = useRef();
  const [isHiddenTableAccount, setIsHiddenTableAccount] = useState(false); // Initially hidden
  const [isDownloadOpen, setIsDownloadOpen] = useState(null);
  const [currentAccountId, setCurrentAccountId] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [unallocatedAccount, setUnallocatedAccount] = useState([]);
  const inputRefAccountFee = useRef(null);
  const [isFocusedAccountBalance, setIsFocusedAccountBalance] = useState(false);
  const [isFocusedMandateAmount, setIsFocusedMandateAmount] = useState(false);
  const [mandateAmount, setMandateAmount] = useState(0);
  const inputRefAccountBalance = useRef(null);
  const inputRefMandateAmount = useRef(null);
  const [showRecordsMandate, setShowRecordsMandate] = useState(10);
  const [currentPageMandate, setCurrentPageMandate] = useState(1);
  const [bankTypeValue, setBankTypeValue] = useState(1);
  const [bankTypeLabel, setBankTypeLabel] = useState("External Bank");
  const [alerts, setAlerts] = useState([]);
  const [preselectedMandateFrequency, setpreselectedMandateFrequency] =
    useState({ value: "adhoc", label: "Adhoc" });
  const [mandateFrequency, setMandateFrequency] = useState("adhoc");
  const [preselectedMandateTerm, setpreselectedMandateTerm] = useState({
    value: "variable",
    label: "Variable",
  });
  const [mandateTerm, setMandateTerm] = useState("variable");
  const AllStatusFilters = [
    { value: null, label: "ALL" },
    { value: "created", label: "Created" },
    { value: "active", label: "Active" },
    { value: "failed", label: "Failed" },
  ];
  const transactionType = [
    { value: "debit", label: "Withdraw" },
    { value: "credit", label: "Deposit" },
  ];
  const bankType = [
    { value: 1, label: "External Bank" },
    { value: 2, label: "Third Party Bank" },
  ];
  const recurringTypes = [
    { value: "never", label: "Never" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ];
  const mandateFrequencyData = [
    { value: "adhoc", label: "Adhoc" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "fortnightly", label: "Fortnightly" },
    { value: "monthly", label: "Monthly" },
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "halfyearly", label: "Half Year" },
    { value: "yearly", label: "Yearly" },
  ];
  const mandateTermsData = [
    { value: "variable", label: "Variable" },
    { value: "fixed", label: "Fixed" },
  ];
  const transactionTypeSecond = [
    { value: "rtgs", label: "RTGS" },
    { value: "international", label: "International" },
    { value: "normal", label: "Overnight" },
    { value: "payto", label: "PayTo" },
  ];
  const headersDashboard = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate", key: "" },
    { label: "Transaction Currency", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Running Balance", key: "" },
    { label: "Transaction Status", key: "" },
    { label: "Gateway Status", key: "" },
    { label: "", key: "" },
  ];
  const mandateHeaders = [
    { label: "#", key: "" },
    { label: "ID", key: "" },
    { label: "Amount", key: "" },
    { label: "Frequncy", key: "" },
    { label: "Type", key: "" },
    { label: "Status", key: "" },
    { label: "Action", key: "" },
  ];
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];
  const [transactionTab, setTransactionTab] = useState("addTransaction");
  const [selectedStatusMandate, setSelectedStatusMandate] = useState(null);

  const [isOpenEdit, setisOpenEdit] = useState(false);
  const clearAllFields = () => {
    setPreselectedTransactionType({
      value: "debit",
      label: "Withdraw",
    });
    setPreselectedTransactionTypeSecond({ value: "rtgs", label: "RTGS" });
    setTransactionTypeValue("debit");
    setTransactionAmount(0);
    setCreationDate(getCurrentDate());
    setRecEndDate("");
    setRecStartDate("");
    setComments("");
    setpreselectedcashAccount({});
    setPreselectedToAccount({});
    // from account
    setFromCurrencyName("");
    setFromCurrencyRate("");
    setFromAccountNumber("");
    setFromBankName("");
    setFromAccountId("");
    // to account
    setToCurrencyName("");
    setToCurrencyRate("");
    setToAccountNumberTransaction("");
    setToBankName("");
    setToAccountId("");
    setSummaryDetails(false);
    setTransactionTypeName("Withdraw");
    setTransactionTypeNameSecond("rtgs");
    setNabFees("$12.00");
  };
  const clearAllFieldsPayId = () => {
    setUserPayID("");
    setCreationDate("");
    setTransactionAmountPayID(0);
    setCommentsPayID("");
    setSummaryDetailsPayID(false);
  };
  const handleSelectMandateFrequency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setMandateFrequency(selectedOption.value);
  };
  const handleSelectMandateTerm = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setMandateTerm(selectedOption.value);
  };
  const handleChangeMandateAmount = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setMandateAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefMandateAmount.current) {
          inputRefMandateAmount.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const clearAllFieldsBank = () => {
    setToAccountName("");
    setpreselectedCurrency({ value: 2, label: "AUD" });
    setpreselectedCountryCode({ value: "AU", label: "Australia" });
    setAddressLine1("");
    setToAccountNumber("");
    setToBank("");
    setAddressLine2("");
    setToBsb("");
    setCountryCode("AU");
    setToCurrency(2);
    setAddressLine3("");
    setSwiftCode("");
    setRoutingNumber("");
    setTransitNumber("");
    setIban("");
  };
  const clearCashAccountFields = () => {
    setNewAccountName("");
    setpreselectedCurrency({ value: 2, label: "AUD" });
    setAccountDescription("");
    setAccountBalance(0);
    setminimumInvestment(0);
    setBufferAmount(0);
    setToCurrency(2);
  };
  useEffect(() => {
    if (
      transactionTypeValue == "debit" &&
      transactionTypeValueSecond == "rtgs"
    ) {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentTime = currentHour + currentMinute / 60;

      const startTime = 9; // 9:00 AM
      const endTime = 15; // 3:00 PM

      if (currentTime >= startTime && currentTime <= endTime) {
        setRTGSAllowed(true);
      } else {
        setRTGSAllowed(false);
      }
    }
  }, [transactionTypeValue, transactionTypeValueSecond]);
  const addCashAccount = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/sub-account`;
    let bodyData = {
      name: newAccountName,
      balance: accountBalance,
      account_id: customerAccountId,
      fee: minimumInvestment,
      fee_buffer: bufferAmount,
      currency_id: toCurrency,
      user_id: userId,
      description: accountDescription,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const togglePopupAddAccount = () => {
    clearCashAccountFields();
    setisOpenAccount(!isOpenAccount);
  };
  const togglePopupAddMandate = () => {
    setIsOpenAddMandate(!isOpenAddMandate);
  };
  const togglePopupProcessPayment = () => {
    setIsOpenProcessPayment(!isOpenProcessPayment);
  };
  const handleChangeAmountBalance = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setAccountBalance(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountBalance.current) {
          inputRefAccountBalance.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const handleChangeAmountFee = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setminimumInvestment(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountFee.current) {
          inputRefAccountFee.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const handleChangeAmountFeeBuffer = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setBufferAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountFeeBuffer.current) {
          inputRefAccountFeeBuffer.current.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }
      }, 0);
    }
  };
  const formatNumber = (value) => {
    // Remove commas before parsing
    const number = parseFloat(value.toString().replace(/,/g, ""));

    if (isNaN(number)) return "";

    // Format with 2 decimal places and add commas
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const formatDateForFilterNew = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}/${month}/${year}`; // Format as yyyy-dd-mm
  };
  const formatDateForFilter = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format as yyyy-dd-mm
  };
  const handleDownloadPDFTableAccount = async () => {
    let headerDashboardFinal = [];
    if (defaultCard && defaultCard.id == "1") {
      headerDashboardFinal = [
        {
          label: "Date & Time",
          key: "date",
          formatter: (val) => formatDateTransaction(val),
        },
        { label: "Transaction ID", key: "reference_code" },
        {
          label: "From Account",
          key: "account_name",
          formatter: (_, row) => {
            if (row.mode == "deposit") {
              return row.bank?.account_name || "";
            } else {
              if (
                row.mode == "withdrawal_rtgs" ||
                row.mode == "withdrawal_international" ||
                row.mode == "withdrawal"
              ) {
                return row.to_account?.name || "";
              }
              if (row.mode == "transfer") {
                return row.from_account?.name || "";
              }
            }
          },
        },
        {
          label: "To Account",
          key: "account_name",
          formatter: (_, row) => {
            if (row.mode == "deposit" || row.mode == "transfer") {
              return row.to_account?.name || "";
            } else {
              if (
                row.mode == "withdrawal_rtgs" ||
                row.mode == "withdrawal_international" ||
                row.mode == "withdrawal"
              ) {
                return row.bank?.account_name || "";
              }
            }
          },
        },
        {
          label: "Convert Rate (AUD)",
          key: "convert_rate",
          formatter: (val) => val.toFixed(2),
        },
        {
          label: "Debit",
          key: "debit",
          formatter: (val) =>
            "$" +
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Credit",
          key: "credit",
          formatter: (val) =>
            "$" +
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Running Balance",
          key: "balance",
          formatter: (val) =>
            "$" +
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        { label: "Transaction Status", key: "status" },
        { label: "Gateway Status", key: "gateway_status" },
      ];
    }

    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, headerDashboardFinal);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8" />
                <style>
                @page {
          size: A4 landscape;
          margin: 0;
        }
          html, body {
                  margin: 0;
                  padding: 0;
                            font-family:sans-serif;
          overflow: auto;  /* Ensure content can overflow */
        
                  height: 100%; /* Ensure the body fills the entire height */
                }        .pdf-container {
                    max-width: 100% !important;
                    margin: 20px;
                  }
                  tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
          
                  .custom-header {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding-top: 10px; /* Ensures no padding at the top */
                  }
          
                  .logo-container {
                    display: flex;
                    align-items: center;
                  }
          
                  .logo {
                    width: 96px; /* Tailwind w-24 = 6rem = 96px */
                    max-width: 150px;
                    height: auto;
                    object-fit: contain;
                    margin-right: 1rem;
                  }
          
                  .title {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 1.125rem; /* Tailwind text-lg */
                    font-weight: 500;    /* Tailwind font-medium */
                    padding: 0;          /* Remove any padding */
                    margin: 0;           /* Remove any margin */
                  }
          
                  .date {
                    font-size: 0.875rem;  /* Tailwind text-sm */
                    font-weight: 500;
                    color: #000000;
                    padding-bottom: 16px;
                  }
        
          
        .page-break {
                 page-break-before: always;
          break-before: page;
          display: block;
          height: 0; /* No extra space */
          width: 100%;
          content: "";}
              table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }
        
            thead {
              font-size: 10px;
              color: #6B7280; /* Tailwind text-labelColour equivalent */
            }
        
            th {
              border-bottom: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
                  td {
              padding: 6px;
              font-size: 10px;
              vertical-align: middle;
              text-align: left;
            }
              .tbody-tr{
                          background-color: #F9F9F9;
                          margin-bottom: 10px;
        
              }
                </style>
              </head>
              <body>
             <div class="pdf-container">
                <div class="custom-header">
                  <div class="logo-container">
                    <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                  </div>
                  <h2 class="title">Transaction History</h2>
                  <div class="date">${date}</div>
                </div>
                
          <table id="dynamic-table">
          ${tableHeader}
            ${tableBody}
        
          </table>
            
              </div> 
        
                   </body>
            </html>
          `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Transaction History-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTableAccount(false);
    setIsOpenDownloadReport(false);
  };
  useEffect(() => {
    if (isHiddenTableAccount == true) {
      handleDownloadPDFTableAccount();
    }
  }, [isHiddenTableAccount]);
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
  };
  const togglePopupAddTransaction = () => setisOpenEdit(!isOpenEdit);
  const handleChangeCashAccount = (selectedOption) => {
    if (selectedOption.value == "new") {
      setTimeout(function () {
        clearAllFieldsBank();
        if (bankTypeValue == 1) {
          setTransactionTab("addBank");
        }
        if (bankTypeValue == 2) {
          setTransactionTab("addThirdPartyBank");
        }
      }, 100);
    } else {
      setFromCurrencyName(selectedOption.currencyName);
      setFromCurrencyRate(selectedOption.rate);
      setFromAccountNumber(selectedOption.accountNumber);
      setFromBankName(selectedOption.bankName);
      setFromAccountId(selectedOption.value);
      setTransactionCurrency(selectedOption.currency);
      setFromAccountName(selectedOption.label);
      setpreselectedcashAccount(selectedOption);
      setUsdRateCashAccount(selectedOption.usd_rate);
    }
  };
  const handleChangeBankType = (selectedOption) => {
    setpreselectedBankType(selectedOption);
    setBankTypeValue(selectedOption.value);
    setBankTypeLabel(selectedOption.label);
    if (transactionTypeValue == "debit") {
      setPreselectedToAccount({});
      setToCurrencyName("");
      setToCurrencyRate("");
      setToAccountNumberTransaction("");
      setToBankName("");
      setToAccountId("");
      setToAccountNameTrans("");
      setUsdRateCashAccountTo(0);
    } else {
      setpreselectedcashAccount({});
      setFromCurrencyName("");
      setFromCurrencyRate("");
      setFromAccountNumber("");
      setFromBankName("");
      setFromAccountId("");
      setTransactionCurrency("");
      setFromAccountName("");
      setUsdRateCashAccount(0);
    }
  };
  const handleChangeToAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    if (selectedOption.value == "new") {
      setTimeout(function () {
        clearAllFieldsBank();
        if (bankTypeValue == 1) {
          setTransactionTab("addBank");
        }
        if (bankTypeValue == 2) {
          setTransactionTab("addThirdPartyBank");
        }
      }, 100);
    } else {
      setToCurrencyName(selectedOption.currencyName);
      setToCurrencyRate(selectedOption.rate);
      setToAccountNumberTransaction(selectedOption.accountNumber);
      setToBankName(selectedOption.bankName);
      setToAccountId(selectedOption.value);
      setToAccountNameTrans(selectedOption.label);
      setPreselectedToAccount(selectedOption);
      setUsdRateCashAccountTo(selectedOption.usd_rate);
    }
  };
  const handleChangeAmount = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setTransactionAmount(rawValue); // Store raw value without commas
      setLastEdited("transaction");

      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
  };
  const handleTransactionType = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    if (selectedOption.value == "credit") {
      setNabFees("$0.15");
    } else {
      setNabFees("$12.00");
    }
    setTransactionTypeValue(selectedOption.value);
    setTransactionTypeName(selectedOption.label);
    setpreselectedcashAccount({});
    setPreselectedToAccount({});
    // from account
    setFromCurrencyName("");
    setFromCurrencyRate("");
    setFromAccountNumber("");
    setFromBankName("");
    setFromAccountId("");
    // to account
    setToCurrencyName("");
    setToCurrencyRate("");
    setToAccountNumberTransaction("");
    setToBankName("");
    setToAccountId("");
    setPreselectedTransactionType(selectedOption);
    setPreselectedTransactionTypeSecond({ value: "rtgs", label: "RTGS" });
    //bank
    setpreselectedBankType({
      value: 1,
      label: "External Bank",
    });
    setBankTypeValue(1);
    setBankTypeLabel("External Bank");
  };
  const handleRecurringType = (selectedOption) => {
    setRecurringTypeValue(selectedOption.value);
    setRecurringTypeLabel(selectedOption.label);
  };
  const handleTransactionTypeSecond = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setTransactionTypeValueSecond(selectedOption.value);
    setTransactionTypeNameSecond(selectedOption.label);
    setPreselectedTransactionTypeSecond(selectedOption);
    if (selectedOption.value == "rtgs") {
      setNabFees("$12.00");
    }
    if (selectedOption.value == "international") {
      setNabFees("$20.00");
    }
    if (selectedOption.value == "normal") {
      setNabFees("$0.15");
    }
  };
  useEffect(() => {
    if (AllAccount.length > 0 && selectedAccounts.length === 0) {
      setSelectedAccounts([AllAccount[0].value]); // Select first account by default
    }
  }, [AllAccount]);

  useEffect(() => {
    if (
      lastEdited === "transaction" &&
      usdRateCashAccount > 0 &&
      usdRateCashAccountTo > 0
    ) {
      const rate = usdRateCashAccount / usdRateCashAccountTo;
      setFinalConvertedAmount((transactionAmount * rate).toFixed(2));
    }
  }, [usdRateCashAccount, usdRateCashAccountTo, transactionAmount, lastEdited]);
  useEffect(() => {
    if (usdRateCashAccount > 0 && usdRateCashAccountTo > 0) {
      setFinalConvertedRate(
        (usdRateCashAccount / usdRateCashAccountTo).toFixed(2)
      );
    }
  }, [usdRateCashAccount, usdRateCashAccountTo]);
  useEffect(() => {
    if (
      lastEdited === "final" &&
      usdRateCashAccount > 0 &&
      usdRateCashAccountTo > 0
    ) {
      const reverseRate = usdRateCashAccountTo / usdRateCashAccount;
      setTransactionAmount((finalConvertedAmount * reverseRate).toFixed(2));
    }
  }, [usdRateCashAccount, usdRateCashAccountTo, finalConvertedAmount]);
  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        backgroundColor:
          defaultCard && defaultCard.id == "1" ? "#8DAAE8" : "#996EE7",
        borderColor: "#4A90E2",
        borderWidth: 1,
        titleColor: "#000000",
        bodyColor: "white",
        displayColors: false,
        callbacks: {
          title: (tooltipItems) => {
            const timestamp = tooltipItems[0].parsed.x; // <-- reliable timestamp
            const date = new Date(timestamp);

            if (
              selectedFilterTransaction === "1M" ||
              selectedFilterTransaction === "3M"
            ) {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });
              const year = date.getFullYear();
              return `${day} ${month} ${year}`;
            } else {
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              return `${month}/${year}`;
            }
          },
          label: (tooltipItem) => {
            // Format the label as $<value>
            return `$${tooltipItem.raw
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
          },
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        type: "time", // Ensure the x-axis uses time scale
        time: {
          unit:
            selectedFilterTransaction.toUpperCase() === "1M" ||
            selectedFilterTransaction.toUpperCase() === "3M" ||
            selectedFilterTransaction.toUpperCase() === "6M"
              ? "day"
              : "month",
          tooltipFormat:
            selectedFilterTransaction.toUpperCase() === "1M" ||
            selectedFilterTransaction.toUpperCase() === "3M" ||
            selectedFilterTransaction.toUpperCase() === "6M"
              ? "MMM d (EEE)"
              : "MMM yyyy",
        },
        grid: { drawOnChartArea: false, drawTicks: false },
        ticks: {
          display: true,
          color: "black",

          callback: function (value) {
            const date = new Date(value);

            if (
              selectedFilterTransaction.toUpperCase() === "1M" ||
              selectedFilterTransaction.toUpperCase() === "3M" ||
              selectedFilterTransaction.toUpperCase() === "6M"
            ) {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });

              return [day, month];
            } else {
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              }); // e.g., Jan
              const year = date.getFullYear();
              return [month, year];
            }
          },
          font: {
            size: 12, // Adjust size to fit the labels properly
          },
          maxRotation: 0,
          minRotation: 0,
        },
        border: { color: "black" },
        afterFit: function (scale) {
          scale.height = 60; // Adjust the height to ensure space for two lines
        },
      },
      y: {
        grid: {
          drawOnChartArea: true, // Show grid lines on the chart area
          drawTicks: false, // Optionally hide ticks on grid lines
          color: "rgba(0, 0, 0, 0.1)", // Set the color of the grid lines (light gray)
          lineWidth: 1, // Set the line width of the grid lines
        },
        ticks: {
          callback: (value) => `${value.toFixed(2)}`,
          color: "black",
          padding: 10, // Add spacing for Y-axis labels
        },
        beginAtZero: false, // Optional: prevent starting at zero
        min: 0, // Adjust this value to add more space above the border
        offset: true, // Add extra space between the border and the graph
        border: { display: false },
      },
    },
  };
  // Predefined quick filters
  const quickFilters = [
    { label: "This Week", value: "this_week" },
    { label: "Last Week", value: "last_week" },
    { label: "This Month", value: "this_month" },
    { label: "This Year", value: "this_year" },
    { label: "Last Year", value: "last_year" },
    { label: "Custom", value: "custom" },
    { label: "All Time", value: "" },
  ];

  // Handle quick filter selection
  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;
    setCurrentPage(1);
    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCountryCode = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/country-codes`);

      if (response.status == 200) {
        let AllAccount = [];
        Object.entries(response.data).forEach(([key, value]) => {
          AllAccount.push({
            value: key,
            label: value,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryCodeData([AllAccount]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  function formatDateTransaction(inputDateString) {
    const cleanedDate = inputDateString.replace(/ [A-Z]{3,4}$/, ""); // Removes " AEDT"

    // Parse and format
    const parsedDate = parse(cleanedDate, "dd/MM/yyyy hh:mm:ss a", new Date());
    return format(parsedDate, "dd/MM/yyyy | HH:mm:ss");
  }
  const strategyTypeData = [
    { value: 1, label: "Whitestone SMA 60/40" },
    { value: 2, label: "Test SMA 80/20" },
    { value: 0, label: "All" },
  ];

  const handleClick = (chartIndex) => {
    setSelectedChart(chartIndex);
    setSelectedIndexPerformance(selectedStockIndex);
    // if (
    //   selectedChart === chartIndex &&
    //   selectedIndexPerformance === selectedStockIndex
    // ) {
    //   // If already selected, deselect on second click
    //   setSelectedChart(null);
    //   setSelectedIndexPerformance(null);
    // } else {
    //   setSelectedChart(chartIndex);
    //   setSelectedIndexPerformance(selectedStockIndex);
    // }
  };

  const handleCustomTimeChange = (change) => {
    setCustomTime((prev) => Math.max(1, prev + change));
    setSelectedFilter("CUSTOM");
  };
  const [preSelectedStrategyType, setPreSelectedStrategyType] = useState(null);
  const [showRecords, setShowRecords] = useState(10);
  const [selectedInvestmentId, setSelectedInvestmentId] = useState(null);
  const [totalInvestedDetails, setTotalInvestedDetails] = useState(null);
  const [filter, setFilter] = useState("transaction");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [stockPrices, setStockprices] = useState([]);
  // From account
  const [fromCurrencyName, setFromCurrencyName] = useState("");
  const [fromCurrencyRate, setFromCurrencyRate] = useState("");
  const [fromAccountNumber, setFromAccountNumber] = useState("");
  const [fromBankName, setFromBankName] = useState("");
  const [fromAccountId, setFromAccountId] = useState(null);
  const [transactionCurrency, setTransactionCurrency] = useState(null);
  const [fromAccountName, setFromAccountName] = useState("");
  const [totalInvested, setTotalInvested] = useState(0);

  //
  // To account
  const [toCurrencyName, setToCurrencyName] = useState(2);
  const [toBankName, setToBankName] = useState("");
  const [toCurrencyRate, setToCurrencyRate] = useState("");
  const [toAccountNumber, setToAccountNumber] = useState("");
  const [toAccountNumberTransaction, setToAccountNumberTransaction] =
    useState("");
  const [toAccountNameTrans, setToAccountNameTrans] = useState("");
  const [toAccountId, setToAccountId] = useState(null);
  const [preselectedToAccount, setPreselectedToAccount] = useState({});
  //
  const [selectedIndexPerformance, setSelectedIndexPerformance] =
    useState(null);
  const buttonRefs = useRef({});
  const accountOptions = ["Archive", "Delete"];

  const cardActivated = useSelector((state) => state.cards.cardExisted);
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const [tooltipData, setTooltipData] = useState({
    day: 5.93,
    month: 3.53,
    year: 8.95,
  });
  const shadowPlugin = {
    id: "shadowPlugin",
    beforeDraw: (chart) => {
      const ctx = chart.ctx;
      ctx.save();
      ctx.shadowColor = "rgba(52, 192, 70, 0.8)";
      ctx.shadowBlur = 15;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 10;
    },
    afterDraw: (chart) => {
      const ctx = chart.ctx;
      ctx.restore();
    },
  };
  const [graphData, setGraphdata] = useState([]);
  const [balanceData, setBalancesData] = useState(0);
  const [totalDepositData, setTotalDepositData] = useState(0);
  const [totalWithdrawData, setTotalWithdraw] = useState(0);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(null); // Tooltip state
  const [selectedperformacefilter, setselectedperformacefilter] = useState(1);
  const [balanceChangeFilterLabel, setBalanceChangeFilterLabel] = useState("");
  const [balanceChangeFilterValue, setBalanceChangeFilterValue] =
    useState("All");
  const [preSelectedBalanceChanges, setpreSelectedBalanceChanges] = useState({
    value: "All",
    label: "All Time Change",
  });
  const [institutionNumber, setinstitutionNumber] = useState("");

  const labelsLine = rawData
    ? rawData.map((item) => {
        const date = new Date(item.date); // Parse the date
        return date; // Return Date object (Chart.js can parse Date objects)
      })
    : [];
  const DeleteAccount = async (accountId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/sub-account/${accountId}`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleshowRecordMandates = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsMandate(parseInt(selectedOption.value));
    setCurrentPageMandate(1);
  };
  const ArchivingAccount = async (accountId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/sub-account/archieve/${accountId}`;
    const bodyData = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleOptionClick = async (option, accountId) => {
    if (option == "Delete") {
      let toastMessage = null;
      try {
        const response = await DeleteAccount(accountId);
        if (response.status == 200) {
          getCashAccountData();
          toastMessage = {
            message: "Account Deleted Successfully!",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            setLoading(false); // Ensure `loading` is false first

            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    if (option == "Archive") {
      let toastMessage = null;

      try {
        const response = await ArchivingAccount(accountId);
        if (response.status == 200) {
          getCashAccountData();
          toastMessage = {
            message: "Account Archived Successfully!",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            setLoading(false);
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    setActiveDropdownId(null);
  };
  const handlePerformanceFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setselectedperformacefilter(selectedOption.value);
  };
  const handleBalanceChangesChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setBalanceChangeFilterValue(selectedOption.value);
    setSelectedFilter(selectedOption.value);
    setBalanceChangeFilterLabel(selectedOption.label);
  };
  const handleSelectStrategyType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setPreSelectedStrategyType(selectedOption);
    setSelectedInvestmentId(selectedOption.value);
    setSelectedFilter("All");
    setBalanceChangeFilterValue("All");
    setpreSelectedBalanceChanges({ value: "All", label: "All Time Change" });
  };

  const handlePieClick = (data, index) => {
    setSelectedIndex(index);
  };
  const handlePieClickPerfomance = (chartIndex, idx) => {
    setSelectedIndices((prev) => ({
      ...prev,
      [chartIndex]: idx, // Set the selected index for the specific chart
    }));
  };
  const toggleDropdownAccount = (accountId) => {
    setActiveDropdownId((prevId) => (prevId === accountId ? null : accountId));
  };
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const performanceFilterOptions = [
    { value: 1, label: "Your Top Gainers" },
    { value: 2, label: "Your Top Underperformers" },
  ];
  const balanceChanges = [
    { value: "All", label: "All Time Change" },
    { value: "1Y", label: "Yearly Change" },
    { value: "1M", label: "Monthly Change" },
    { value: "1W", label: "Weekly Change" },
    // { value: "24H", label: "24H Change" },
  ];
  const resetAllFilters = () => {
    setSearchAccount("");
    setSelectedAccounts(["ALL"]);
    setSearchQuery("");
    setSelectedDates([]);
    setSelectedRange("Select Date Range");
    setQuickFilter("");
    setTransactionStatus("");
    setCurrentPage(1);
    setShowRecords(10);
    setExpandedRow(null);
    setpreSelectedFilter({
      value: 10,
      label: "10",
    });
  };
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  const toggleDownloadDropdown = (accountId) => {
    setIsDownloadOpen((prevId) => (prevId === accountId ? null : accountId));
  };
  const downloadExcelReportAccount = async (accountId) => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl = "";
      apiUrl = `/v1/merchant/dashboard/transaction/list/export/excel?page=1&size=1000&account_ids=${accountId}`;
      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleSelectStatus = async (option) => {
    setSelectedStatusMandate(option.value);
    setIsStatusOpenMandate(false);
    setCurrentPageMandate(1);
  };
  const handleDownload = async (accountId, format) => {
    if (format === "pdf") {
      // Trigger PDF download
      try {
        setLoading(true);
        let apiUrl = "";
        apiUrl = `/v1/merchant/dashboard/transaction/list?page=1&size=1000&account_ids=${accountId}`;
        const response = await GetAPIcalls(apiUrl);

        if (response.status == 200) {
          if (response.data == null || response.data.transactions.length == 0) {
            setPdfData([]);
            setIsHiddenTableAccount(false);
            setLoading(false);
            toggleDownloadDropdown(accountId);
            showToast("No data available to generate the report.", "error");
          } else {
            setPdfData(response.data.transactions);
            toggleDownloadDropdown(accountId);

            setIsHiddenTableAccount(true);
          }
        } else {
          if (response.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
        }
      } catch (err) {
        if (err.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setPdfData([]);
        setLoading(false);
        setIsOpenDownloadReport(false);
        showToast(err.message, "error");
      }
    } else if (format === "excel") {
      // Trigger Excel download
      setLoading(true);
      try {
        const csvBlob = await downloadExcelReportAccount(accountId);
        const url = window.URL.createObjectURL(csvBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Transaction History-${formattedDate}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        toggleDownloadDropdown(accountId);
        setTimeout(function () {
          setLoading(false); // Ensure `loading` is false first
        }, 100);
      }
    }
  };
  const handleAccountListChange = (option) => {
    setSelectedAccounts((prev) => {
      if (option.value === "ALL") {
        // If "ALL" is selected, replace the array with only "ALL"
        return prev.includes("ALL") ? [] : ["ALL"];
      } else {
        // If a regular option is selected
        const updatedAccounts = prev.includes(option.value)
          ? prev.filter((item) => item !== option.value) // Remove if already selected
          : [...prev.filter((item) => item !== "ALL"), option.value]; // Add and remove "ALL" if necessary
        return updatedAccounts;
      }
    });
  };

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [preSelectedFilterMandate, setpreSelectedFilterMandate] = useState({
    value: 10,
    label: "10",
  });
  const [preSelectedperformacefilter, setpreSelectedperformacefilter] =
    useState({
      value: 1,
      label: "Your Best gainers",
    });
  const recentactivityheader = [
    { label: "Detail", key: "" },
    { label: "Date", key: "" },
    { label: "Amount", key: "" },
  ];
  const withOutheadersDashboard = [
    { label: "Date & Time", key: "" },
    { label: "Transaction ID", key: "" },
    { label: "Account Name", key: "" },
    { label: "Convert Rate", key: "" },
    { label: "Transaction Currency", key: "" },
    { label: "Debit", key: "" },
    { label: "Credit", key: "" },
    { label: "Transaction Status", key: "" },
    { label: "Gateway Status", key: "" },
    { label: "", key: "" },
  ];
  const chartData = {
    labels: graphData.map((point) => point.month), // Labels for each month
    datasets: [
      {
        label: "Account Balance",
        data: graphData.map((point) => point.balance), // Values for each month
        backgroundColor: "#8DAAE8", // Bar color
        borderColor: "#8DAAE8",
        borderWidth: 2,
        borderRadius: 5, // Rounds the edges of the bars
        hoverBackgroundColor: "#8DAAE8",
        hoverBorderColor: "black",
      },
    ],
  };

  const chartOptions = {
    responsive: true,

    plugins: {
      legend: {
        display: false, // Remove the legend
      },
      tooltip: {
        enabled: true, // Disable the default tooltip

        backgroundColor: "black",
        borderColor: "black",
        borderWidth: 1,
        titleColor: "#8DAAE8",
        bodyColor: "white",
        position: "average", // Tooltip positioned at the nearest point

        displayColors: false, // Remove the color box next to the tooltip text

        callbacks: {
          title: (tooltipItems) => {
            const monthAbbr = tooltipItems[0].label;
            const date = new Date(`${monthAbbr} 1, 2025`);
            const options = { month: "long" };
            const fullMonthName = date.toLocaleString("en-US", options);
            return `${fullMonthName} Portfolio Balance`;
          },
          label: (tooltipItem) => {
            // Format the label as $<value>
            return `        $${tooltipItem.raw
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}    `;
          },
        },
        padding: 10, // Padding inside the tooltip for spacing
      },
    },
    scales: {
      y: {
        grid: {
          drawOnChartArea: true,
          color: "rgba(0, 0, 0, 0.08)", // Set grid line color
          lineWidth: 1, // Set grid line thickness
          drawTicks: false,
        },
        ticks: {
          display: false, // Hide tick marks on the Y-axis
        },
        beginAtZero: false, // Optional: prevent starting at zero
        min: 0, // Adjust this value to add more space above the border
        border: { display: false },
        max: Math.max(...graphData.map((point) => point.balance)) * 1.1, // Dynamic scaling of Y-axis
      },
      x: {
        grid: {
          display: false, // Remove grid lines on the X-axis
        },
        ticks: {
          display: true,
          color: "black",
          font: {
            size: 12, // Adjust size to fit the labels properly
          },
          maxRotation: 0,
          minRotation: 0,
        },
      },
    },
  };
  const handleChangeIban = (e) => {
    const value = e.target.value.toUpperCase(); // IBANs are uppercase
    setIban(value);
  };
  const GetInvestmentList = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    // const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    let apiUrl = "";
    if (selectedDates.length == 2) {
      apiUrl = `${BASE_URL}/v1/merchant/dashboard/transaction/list?page=${currentPage}&search=${searchQuery}&size=${showRecords}&start_date=${formatDateForFilter(
        selectedDates[0]
      )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl = `${BASE_URL}/v1/merchant/dashboard/transaction/list?page=${currentPage}&search=${searchQuery}&size=${showRecords}&account_ids=${
        selectedAccounts[0] == "ALL" ? [] : selectedAccounts
      }`;
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const addTransaction = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/transaction/create`;
    let bodyData = {};
    let mode = "";
    if (transactionTypeValueSecond == "rtgs") {
      mode = "withdrawal_rtgs";
    }
    if (transactionTypeValueSecond == "international") {
      mode = "withdrawal_international";
    }
    if (transactionTypeValueSecond == "normal") {
      mode = "withdrawal";
    }
    if (transactionTypeValue == "debit") {
      bodyData = {
        transaction_type: "debit",
        transaction_mode: mode,
        amount: Number(transactionAmount),
        currency_id: transactionCurrency,
        from_sub_account_id: fromAccountId,
        to_bank_account_id: toAccountId,
        date: creationDate,
        description: comments,
        session_id: sessionId,
        exchange_rate:
          transactionTypeValueSecond == "international"
            ? finalConvertedRate
            : 0,
      };
    } else {
      bodyData = {
        transaction_type: "credit",
        transaction_mode: "deposit",
        amount: Number(transactionAmount),
        currency_id: transactionCurrency,
        to_sub_account_id: toAccountId,
        from_bank_account_id: fromAccountId,
        date: creationDate,
        description: comments,
        session_id: sessionId,
      };
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const toggleClientPop = (accountId) => {
    setPayId("");
    setIsClientPopupOpen((prevId) => (prevId === accountId ? null : accountId));
  };
  const sendOtp = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/transaction/otp/create`;
    let bodyData = {};

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleBsbChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setToBsb(numericValue);

    // Validation: must be 6 digits
    if (numericValue.length === 0) {
      setBsbError("BSB is required");
    } else if (numericValue.length !== 6) {
      setBsbError("BSB must be 6 digits");
    } else {
      setBsbError("");
    }
  };
  const sendotpVerification = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/transaction/otp/verify`;
    let bodyData = {
      otp_code: otp,
      session_id: sessionId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };

  useEffect(() => {
    // Ensure the graphData and chartRef are available before proceeding
    if (graphData.length > 0 && chartRef.current) {
      if (!chartInstance) {
        // Create a new chart instance only if it doesn't exist
        const newChartInstance = new Chart(chartRef.current, {
          type: "bar", // Chart type
          data: chartData,
          options: chartOptions,
        });
        setChartInstance(newChartInstance); // Save the instance
      } else {
        // Update the existing chart instance
        chartInstance.data = chartData; // Update the data
        chartInstance.update(); // Re-render the chart
      }
    }

    // Cleanup function to destroy the chart instance
    return () => {
      if (chartInstance) {
        chartInstance.destroy();
        setChartInstance(null); // Reset the instance
      }
    };
  }, [graphData]); // Depend only on graphData
  // Dependencies include graphData and chartData
  const dataLine = {
    labels: labelsLine,
    datasets: [
      {
        label: "Price",
        data: stockPrices,
        borderColor:
          defaultCard && defaultCard.id == "1" ? "#8DAAE8" : "#996EE7",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Wait until the chart is fully rendered
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(
            0,
            defaultCard && defaultCard.id == "1"
              ? "rgba(74, 144, 226, 0.1)"
              : "rgba(153, 110, 231, 0.1)"
          ); // Light blue at the top
          gradient.addColorStop(1, "white"); // White at the bottom

          return gradient;
        },
        fill: true,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor:
          defaultCard && defaultCard.id == "1" ? "#8DAAE8" : "#996EE7",
      },
    ],
  };
  const handleAddTransacion = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      if (Number(transactionAmount) > 500000) {
        try {
          const response = await sendOtp();
          if (response.status == 200) {
            togglePopupAddTransaction();
            setSessionId(response.data.session_id);
            setMobileNumber(response.data.phone_number);
            setTimeout(function () {
              setIsOpenOTP(true);
            }, 300);
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        try {
          const response = await addTransaction();
          if (response.status == 200) {
            getAllUserTransactions();
            setisOpenEdit(false);
            toastMessage = {
              message:
                "Transaction created successfully. Please check your authenticator app to proceed further",
              type: "success",
            };
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      }
    }, 1000), // Debounce time
    [
      transactionTypeValue,
      transactionAmount,
      transactionCurrency,
      toAccountId,
      fromAccountId,
      creationDate,
      comments,
      finalConvertedAmount,
      finalConvertedRate,
    ] // Dependencies
  );
  const handleSendOtp = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      let secondToast = null;
      try {
        const response = await sendotpVerification();
        if (response.status == 200 && response.data.verified == true) {
          setIsOpenOTP(false);
          setIsOpenOTPEmail(true);
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [otp, sessionId] // Dsendependencies
  );
  const handleSendOtpEmail = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      let secondToast = null;
      try {
        const response = await sendotpVerification();
        if (response.status == 200 && response.data.verified == true) {
          try {
            const responsetrans = await addTransaction();
            if (responsetrans.status == 200) {
              getAllUserTransactions();
              setisOpenEdit(false);
              setIsOpenOTP(false);
              setIsOpenOTPEmail(false);
              secondToast = {
                message:
                  "Transaction created successfully. Please check your authenticator app to proceed further",
                type: "success",
              };
            } else {
              secondToast = { message: responsetrans.message, type: "error" };
            }
          } catch (err) {
            secondToast = { message: err.message, type: "error" };
          } finally {
            setLoading(false); // Ensure `loading` is false first
            // Show toast after loading is false
            if (secondToast) {
              setTimeout(() => {
                showToast(secondToast.message, secondToast.type);
              }, 300); // Small delay if needed
            }
          }
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [otp, sessionId] // Dsendependencies
  );
  const addBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let bodyData = {};
    let apiUrl = "";
    if (transactionTab === "addThirdPartyBank") {
      apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/add/external`;
      bodyData = {
        bank_name: toBank,
        account_number: toAccountNumber,
        account_bsb: toBsb,
        account_name: toAccountName,
        currency_id: toCurrency,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_line3: addressLine3,
        country_code: countryCode,
        swift_code: swiftCode,
        routing_number: routingNumber,
        institution_number: institutionNumber,
        transit_number: transitNumber,
        iban: iban,
        user_id: userId,
      };
    } else {
      apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/add`;
      bodyData = {
        bank_name: toBank,
        account_number: toAccountNumber,
        account_bsb: toBsb,
        account_name: toAccountName,
        currency_id: toCurrency,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_line3: addressLine3,
        country_code: countryCode,
        swift_code: swiftCode,
        routing_number: routingNumber,
        institution_number: institutionNumber,
        transit_number: transitNumber,
        iban: iban,
      };
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAddBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addBank();
        if (response.status == 200 || response.status == 201) {
          setisOpenEdit(false);
          toastMessage = {
            message:
              "Bank added successfully, Please upload proof documents via authenticator app",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const handleEditClick = (e, rowData) => {
    setcurrentAccount(rowData.id);
    setIsModalOpenAccountEdit(true);
    setAccountName(rowData.name);
  };
  const editAccount = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/sub-account/${currentAccount}`;
    const bodyData = {
      user_id: userId,
      name: acccountName,
      description: accountDescription,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleEditAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editAccount();
        if (response.status == 200) {
          setcurrentAccount(null);
          setIsModalOpenAccountEdit(false);
          getCashAccountData();
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, acccountName, accountDescription] // Dependencies
  );
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white px-1 py-2 shadow-lg rounded-full border border-gray-200">
          <p className="text-xs text-black">{payload[0].value}%</p>
        </div>
      );
    }
    return null;
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const GetAPIcallsPrev = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        DateCalendarRef.current &&
        !DateCalendarRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );
      if (isOutside) {
        setActiveDropdownId(null); // Close dropdown if clicked outside
      }
      if (DownloadRef.current && !DownloadRef.current.contains(event.target)) {
        setIsOpenDownloadReport(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const getCardData = async () => {
    setIsLoadingCard(true);
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/stats?currency=${cardCurrencyName.label}`
      );
      if (response.status == 200) {
        // const responseCurrentSystem = await GetAPIcallsPrev(
        //   `https://map.admin.caprock.com.au/api/customer-account-balance`
        // );
        const responseCurrentSystem = {
          status: "success",
          data: {
            accounts: {
              "Cash Account": 4165868.76,
              "Fund Management": 0,
              "Securities": 0,
              "Trading Account": 0,
              "Private Wealth": "inactive",
              "Custodian": 0,
              "My Investment - SMA": 0,
              "Digital Assets ": 0,

            },
          },
        };
        if (responseCurrentSystem.status == "success") {
          // if (response.status == 200) {
          const cardData = [
            {
              label: "Cash Account",
              id: "1",
              amount: response.data.total_cashaccount.total_balance
                ? response.data.total_cashaccount.total_balance.toFixed(2)
                : "0.00",
              accounts: 2,
              isLocked: false,
              color: "bg-[#5D88F8] bg-opacity-100",
              lessColor: "bg-[#5D88F8] bg-opacity-40",
              tail: "border-t-[#5D88F8] border-b-[#5D88F8]  border-opacity-100",
              graphdata: {
                labels: response.data.total_cashaccount.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_cashaccount.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Private Wealth Account",
              id: "2",
              amount: response.data.private_wealth_account.total_balance
                ? response.data.private_wealth_account.total_balance.toFixed(2)
                : "0.00",
              accounts: 1,
              isLocked: false,
              color: "bg-[#996EE7] bg-opacity-100",
              lessColor: "bg-[#996EE7] bg-opacity-40",
              tail: "border-t-[#996EE7] border-opacity-100",

              graphdata: {
                labels:
                  response.data.private_wealth_account.daily_transactions.map(
                    (item) => item.date
                  ),
                datasets: [
                  {
                    data: response.data.private_wealth_account.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "My Investments",
              id: "3",
              amount: response.data.my_investments.total_balance
                ? response.data.my_investments.total_balance
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : "0.00",
              accounts: 0,
              isLocked: false,
              color: "bg-[#6B68F2] bg-opacity-100",
              lessColor: "bg-[#6B68F2] bg-opacity-40",
              tail: "border-t-[#6B68F2] border-opacity-100",

              graphdata: {
                labels: response.data.my_investments.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.my_investments.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Private Wealth  (Commodities)",
              id: "10",
              amount:
                responseCurrentSystem.data.accounts["Private Wealth"] !=
                "inactive"
                  ? responseCurrentSystem.data.accounts[
                      "Private Wealth"
                    ].toFixed(2)
                  : "0.00",
              accounts: 2,
              isLocked:
                responseCurrentSystem.data.accounts["Private Wealth"] ==
                "inactive"
                  ? true
                  : false,
              color: "bg-[#DC4646] bg-opacity-100",
              lessColor: "bg-[#DC4646] bg-opacity-40",
              tail: "border-t-[#DC4646] border-opacity-100",
              graphdata: {
                labels: response.data.total_tradings.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_tradings.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "My Investment (Securities)",
              id: "5",
              amount:
                responseCurrentSystem.data.accounts["My Investment - SMA"] !=
                "inactive"
                  ? responseCurrentSystem.data.accounts[
                      "My Investment - SMA"
                    ].toFixed(2)
                  : "0.00",
              accounts: 1,
              isLocked:
                responseCurrentSystem.data.accounts["My Investment - SMA"] ==
                "inactive"
                  ? true
                  : false,
              color: "bg-[#84CC16] bg-opacity-100",
              lessColor: "bg-[#84CC16] bg-opacity-40",
              tail: "border-t-[#84CC16] border-opacity-100",

              graphdata: {
                labels: response.data.digital_assets.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.digital_assets.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Fund Management",
              id: "6",
              amount:
                responseCurrentSystem.data.accounts["Fund Management"] !=
                "inactive"
                  ? responseCurrentSystem.data.accounts[
                      "Fund Management"
                    ].toFixed(2)
                  : "0.00",
              isLocked:
                responseCurrentSystem.data.accounts["Fund Management"] ==
                "inactive"
                  ? true
                  : false,
              accounts: 1,
              color: "bg-[#14B8A6] bg-opacity-100",
              lessColor: "bg-[#14B8A6] bg-opacity-40",
              tail: "border-t-[#14B8A6] border-opacity-100",

              graphdata: {
                labels: response.data.digital_assets.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.digital_assets.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Trading",
              id: "4",
              amount: response.data.total_tradings.total_balance
                ? response.data.total_tradings.total_balance
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : "0.00",
              accounts: 2,
              color: "bg-[#DC4646] bg-opacity-100",
              lessColor: "bg-[#DC4646] bg-opacity-40",
              tail: "border-t-[#DC4646] border-opacity-100",
              graphdata: {
                labels: response.data.total_tradings.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_tradings.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Custodian",
              id: "7",
              amount:
                responseCurrentSystem.data.accounts.Custodian != "inactive"
                  ? responseCurrentSystem.data.accounts.Custodian.toFixed(2)
                  : "0.00",
              isLocked:
                responseCurrentSystem.data.accounts.Custodian == "inactive"
                  ? true
                  : false,
              accounts: 0,
              color: "bg-[#2DB0EC] bg-opacity-100",
              lessColor: "bg-[#2DB0EC] bg-opacity-40",
              tail: "border-t-[#2DB0EC] border-opacity-100",

              graphdata: {
                labels: response.data.total_custodians.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_custodians.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Securities",
              id: "8",
              amount:
                responseCurrentSystem.data.accounts.Securities != "inactive"
                  ? responseCurrentSystem.data.accounts.Securities.toFixed(2)
                  : "0.00",
              isLocked:
                responseCurrentSystem.data.accounts.Securities == "inactive"
                  ? true
                  : false,
              accounts: 1,
              color: "bg-[#F18C29] bg-opacity-100",
              lessColor: "bg-[#F18C29] bg-opacity-40",
              tail: "border-t-[#F18C29] border-opacity-100",
              graphdata: {
                labels: response.data.total_securities.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_securities.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Digital Assets",
              id: "9",
              amount:
                responseCurrentSystem.data.accounts["Digital Assets "] !=
                "inactive"
                  ? responseCurrentSystem.data.accounts[
                      "Digital Assets "
                    ].toFixed(2)
                  : "0.00",
              accounts: 0,
              isLocked:
                responseCurrentSystem.data.accounts["Digital Assets "] ==
                "inactive"
                  ? true
                  : false,
              lessColor: "bg-[#4ADE80] bg-opacity-100",
              color: "bg-[#4ADE80] bg-opacity-40",
              tail: "border-t-[#4ADE80] border-opacity-100",

              graphdata: {
                labels: response.data.digital_assets.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.digital_assets.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Old System",
              id: "10",
              amount:
                responseCurrentSystem.data.accounts["Digital Assets "] !=
                "inactive"
                  ? responseCurrentSystem.data.accounts[
                      "Digital Assets "
                    ].toFixed(2)
                  : "0.00",
              accounts: 0,
              isLocked:
                responseCurrentSystem.data.accounts["Digital Assets "] ==
                "inactive"
                  ? true
                  : false,
              lessColor: "bg-[#4ADE80] bg-opacity-100",
              color: "bg-[#4ADE80] bg-opacity-40",
              tail: "border-t-[#4ADE80] border-opacity-100",

              graphdata: {
                labels: response.data.digital_assets.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.digital_assets.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
          ];
          const defaultCard = cardData.find(
            (card) => card.id === cardActivated
          );
          if (cardId) {
            setDefaultCard(cardData[cardId]);
          } else {
            setDefaultCard(defaultCard || cardData[0]);
          }
          setcardData(cardData);
        } else {
          setcardData([]);
          setDefaultCard({});
          showToast(response.message, "error");
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setcardData([]);
          setDefaultCard({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoadingCard(false);
      }, 100);
    }
  };
  const handleTransitChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setTransitNumber(numericValue);

    // Validation: must be 5 digits
    if (numericValue.length === 0) {
      setTransitError("Transit number is required");
    } else if (numericValue.length !== 5) {
      setTransitError("Transit number must be 5 digits");
    } else {
      setTransitError("");
    }
  };
  const getAccountBalancesData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/account-balances?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setGraphdata(response.data.monthly_balances);
        setBalancesData(response.data);
        if (chartInstance) {
          chartInstance.destroy();
          setChartInstance(null); // Reset the instance
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setcardData([]);
          setDefaultCard({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getCashAccountData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/cash-accounts?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setCashAccountData(response.data);
        const AccountData = [];
        let AllAccount = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
            accountNumber: profile.account_number,
            currency: profile.currency.id,
            usd_rate: profile.currency.rate,
            currencyName: profile.currency.name,
            bankName: "",
          });
          AllAccount.push({
            value: profile.id,
            label: profile.name + " - " + profile.currency.name,
          });
        });
        AllAccount.push({
          value: "ALL",
          label: "ALL",
        });
        setAllAccounts(AllAccount);
        setCashAccountForPopup(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setCashAccountData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getBankAccountData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/account/external-bank/list?status=approved`
      );

      if (response.status == 200) {
        const AccountData = [];
        AccountData.push({
          value: "new",
          label: "Add New Bank...",
        });
        response.data.banks.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.account_name,
            accountNumber: profile.account_number,
            currency: profile.currency.id,
            bankName: profile.bank_name,
            usd_rate: profile.currency.rate,
            currencyName: profile.currency.name,
          });
        });
        setBankAccountData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setBankAccountData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getThirdPartyBankAccountData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/account/external-bank/list/external?page=1&limit=100&status=approved`
      );

      if (response.status == 200) {
        const AccountData = [];
        AccountData.push({
          value: "new",
          label: "Add New Bank...",
        });
        response.data.bank_accounts.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.account_name,
            accountNumber: profile.account_number,
            currency: profile.currency.id,
            bankName: profile.bank_name,
            usd_rate: profile.currency.rate,
          });
        });
        setThirdPartyBankAccountData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setThirdPartyBankAccountData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getTotalDepositData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/total-deposits?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setTotalDepositData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setcardData([]);
          setDefaultCard({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getTotalWithdrawData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/total-withdrawals?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setTotalWithdraw(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setcardData([]);
          setDefaultCard({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllInvestmentList = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/investments-names`
      );

      if (response.status == 200) {
        const investmentList = [];
        // investmentList.push({
        //   value: null,
        //   label: "All",
        // });
        if (response.data.length > 0) {
          response.data.forEach((profile) => {
            investmentList.push({
              value: profile.id,
              label: "Caprock Model Portfolio - " + profile.name,
            });
          });
          handleSelectStrategyType(investmentList[0]);
          setInvestmentList(investmentList);
        } else {
          investmentList.push({
            value: null,
            label: "No investments found",
          });
          handleSelectStrategyType(investmentList[0]);
          setInvestmentList(investmentList);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setInvestmentList([]);
          handleSelectStrategyType({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllInvestmentBreakdown = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/investment-breakdown?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setTotalInvestedInBreakdown(response.data.total_invested);
        setBreakdown(response.data.breakdown);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setTotalInvestedInBreakdown(0);
          setBreakdown([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getRecentAcivity = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/recent-dividend-activity`
      );

      if (response.status == 200) {
        setRecentActivityData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setRecentActivityData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getPerformerData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/portfolio-performance-rankings?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setGainers(response.data.top_performers);
        setLosers(response.data.bottom_performers);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      setGainers([]);
      setLosers([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getFavouriteList = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/favorite-portfolios`
      );

      if (response.status == 200) {
        setHighlightData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setHighlightData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllInvestmentDetails = async () => {
    setIsLoadingDetails(true);
    let toastMessage = null;
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/investment-details/${selectedInvestmentId}`
      );

      if (response.status == 200) {
        setTotalInvestedDetails(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setcardData([]);
          setDefaultCard({});
          toastMessage = { message: response.message, type: "error" };
        }
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setIsLoadingDetails(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const fetchSpecificData = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/my-investment/performance?currency=${cardCurrencyName.label}`;
    const bodyData = {
      portfolio_id: selectedInvestmentId,
      time_interval: selectedFilter.toUpperCase(),
      user_id: userId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const fetchSpecificGraphData = useCallback(
    debounce(async (e) => {
      setIsLoadingGraph(true);
      let toastMessage = null;
      try {
        const response = await fetchSpecificData();

        if (response.status == 200) {
          setPerformanceGraph(response.data.performance_data);
        } else {
          if (response.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          if (response.status === 400) {
            toastMessage = { message: response.message, type: "error" };
          }
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        // Show toast after loading is false
        setIsLoadingGraph(false);

        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [selectedFilter, selectedInvestmentId, userId, cardCurrencyName] // Dependencies
  );
  const getDividend = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/my-investment/portfolio/dividend-details?currency=${cardCurrencyName.label}`;
    let bodyData = {
      portfolio_id: selectedInvestmentId,
      user_id: userId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllInvestmentDividend = async () => {
    let toastMessage = null;
    try {
      const response = await getDividend();

      if (response.status == 200) {
        setTotalDividend(response.data.total_dividends);
        setTotalThreshold(response.data.reinvest_threshold);
        setTotalInvested(response.data.total_invested);
        setTotalInvestedDetails(response.data.balance_changes);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          toastMessage = { message: response.message, type: "error" };
        }
        setTotalDividend(0);
        setTotalThreshold(0);
      }
    } catch (err) {
      setTotalDividend(0);
      setTotalThreshold(0);
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setIsLoadingGraph(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleSubmitMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message

      try {
        //const response = await postLoginSubmitted(userId, otp);
        // if (response.status == 200) {
        //  } else {
        //   toastMessage = { message: response.message, type: "error" };
        //   return;
        // }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [otp, userId] // Dependencies
  );
  const toggleRowDetails = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };
  const getAllUserTransactions = async () => {
    try {
      const response = await GetInvestmentList();

      if (response.status == 200) {
        setTransactionTableData(response.data.transactions);
        setCurrentPage(response.data.page);
        settotalPages(response.data.total_pages);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const sendCodeToverify = async (userId) => {
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/transaction/otp/resend`;
    const bodyData = {
      session_id: sessionId,
    };
    const token = localStorage.getItem("jwtToken");

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const SendCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message
      try {
        const response = await sendCodeToverify();
        if (response.status == 200) {
          toastMessage = {
            message: "OTP sent successfully!",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [sessionId] // Dependencies
  );
  const GetGraphData = async (accountType) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/sub-account/graph`;

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      period: selectedFilterTransaction.toUpperCase(),
      sub_account_type: accountType,
      currency: cardCurrencyName.label,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllTransactionGraphdata = useCallback(
    debounce(async (accountType) => {
      setIsLoadingGraph(true);
      let toastMessage = null;
      try {
        const response = await GetGraphData(accountType);

        if (response.status == 200) {
          if (response.data.length > 0) {
            setrawData(response.data[0].data);
            const stockPrices = response.data[0].data.map(
              (item) => item.amount
            );
            setStockprices(stockPrices);
          } else {
            setrawData([]);
            setStockprices([]);
          }
        } else {
          if (response.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setTimeout(() => {
          setIsLoadingGraph(false);
          if (toastMessage) {
            showToast(toastMessage.message, toastMessage.type);
          }
        }, 300); // Small delay if needed
      }
    }, 1000),
    [selectedFilterTransaction, cardCurrencyName] // Dependencies
  );
  useEffect(() => {
    if (defaultCard.id == 1) {
      getAccountBalancesData();
      getTotalDepositData();
      getTotalWithdrawData();
      getCashAccountData();
      getAllCurrency();
      getAllCountryCode();
      getAllTransactionGraphdata("cash_account");
    }
    if (defaultCard.id == 2) {
      getAllInvestmentList();
      getAllInvestmentBreakdown();
      getRecentAcivity();
      getPerformerData();
      getFavouriteList();
    }
  }, [defaultCard, cardCurrencyName]);
  useEffect(() => {
    if (defaultCard.id == 1) {
      getAllUserTransactions();
    }
  }, [
    defaultCard,
    searchQuery,
    showRecords,
    currentPage,
    selectedDates,
    selectedAccounts,
  ]);

  useEffect(() => {
    getCardData();
  }, [cardCurrencyName]);
  useEffect(() => {
    if (defaultCard.id == 1) {
      getAllTransactionGraphdata("cash_account");
    }
  }, [defaultCard, selectedFilterTransaction]);
  useEffect(() => {
    if (defaultCard.id == 2 && selectedInvestmentId != null) {
      // getAllInvestmentGraph();
      fetchSpecificGraphData();
    }
  }, [selectedFilter, selectedInvestmentId, userId, cardCurrencyName]);
  useEffect(() => {
    if (defaultCard.id == 2 && selectedInvestmentId != null) {
      getAllInvestmentDividend();
    }
  }, [selectedInvestmentId, userId, cardCurrencyName]);
  const getCurrentMonthYear = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const today = new Date();
    const month = months[today.getMonth()]; // Get month name
    const year = today.getFullYear(); // Get current year
    return `${month}, ${year}`; // Format as "Jan, 2025"
  };

  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl = "";
      if (selectedDates.length == 2) {
        apiUrl = `/v1/merchant/dashboard/transaction/list/export/excel?page=${currentPage}&search=${searchQuery}&size=1000&start_date=${formatDateForFilter(
          selectedDates[0]
        )}&end_date=${formatDateForFilter(selectedDates[1])}`;
      } else {
        apiUrl = `/v1/merchant/dashboard/transaction/list/export/excel?page=${currentPage}&search=${searchQuery}&size=1000&account_ids=${
          selectedAccounts[0] == "ALL" ? [] : selectedAccounts
        }`;
      }
      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDFTable = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReport();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Transaction History-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setIsOpenDownloadReport(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          let apiUrl = "";
          if (selectedDates.length == 2) {
            apiUrl = `/v1/merchant/dashboard/transaction/list?page=${currentPage}&search=${searchQuery}&size=1000&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
          } else {
            apiUrl = `/v1/merchant/dashboard/transaction/list?page=${currentPage}&search=${searchQuery}&size=1000&account_ids=${
              selectedAccounts[0] == "ALL" ? [] : selectedAccounts
            }`;
          }
          const response = await GetAPIcalls(apiUrl);

          if (response.status == 200) {
            if (response.data.transactions.length == 0) {
              setPdfData([]);
              setIsHiddenTable(false);
              setLoading(false);
              showToast("No data available to generate the report.", "error");
            } else {
              setPdfData(response.data.transactions);
              setIsHiddenTable(true);
            }
          } else {
            setLoading(false);
            setPdfData([]);
          }
        } catch (err) {
          setPdfData([]);
          setLoading(false);
          showToast(err.message, "error");
        } finally {
          setIsOpenDownloadReport(false);
        }
      }
    }, 1000), // Debounce time
    [selectedDates, currentPage, searchQuery, selectedAccounts] // Dependencies
  );
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  function createTableBody(data, columns) {
    const body = document.createElement("tbody");

    data.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = columns
        .map(({ key, formatter }) => {
          let value = row[key];
          if (formatter) {
            value = formatter(value, row);
          }
          return `<td>${value !== undefined ? value : ""}</td>`;
        })
        .join("");

      body.appendChild(tr);
    });

    return body;
  }
  const handleAddCashAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addCashAccount();
        if (response.status == 201) {
          setisOpenAccount(false);
          getCashAccountData();

          toastMessage = {
            message: "Account Created Successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      newAccountName,
      accountBalance,
      minimumInvestment,
      bufferAmount,
      accountDescription,
      toCurrency,
      customerAccountId,
    ] // Dependencies
  );
  const handleDownloadPDFTable = async () => {
    let headerDashboardFinal = [];
    if (
      transactionTableData != null &&
      (selectedAccounts.length > 1 ||
        selectedAccounts.length == 0 ||
        selectedAccounts.includes("ALL"))
    ) {
      headerDashboardFinal = [
        {
          label: "Date & Time",
          key: "date",
          formatter: (val) => formatDateTransaction(val),
        },
        { label: "Transaction ID", key: "reference_code" },
        {
          label: "From Account",
          key: "account_name",
          formatter: (_, row) => {
            if (row.mode == "deposit") {
              return row.bank?.account_name || "";
            } else {
              if (
                row.mode == "withdrawal_rtgs" ||
                row.mode == "withdrawal_international" ||
                row.mode == "withdrawal"
              ) {
                return row.to_account?.name || "";
              }
              if (row.mode == "transfer") {
                return row.from_account?.name || "";
              }
            }
          },
        },
        {
          label: "To Account",
          key: "account_name",
          formatter: (_, row) => {
            if (row.mode == "deposit" || row.mode == "transfer") {
              return row.to_account?.name || "";
            } else {
              if (
                row.mode == "withdrawal_rtgs" ||
                row.mode == "withdrawal_international" ||
                row.mode == "withdrawal"
              ) {
                return row.bank?.account_name || "";
              }
            }
          },
        },
        {
          label: "Convert Rate",
          key: "convert_rate",
          formatter: (val) => val.toFixed(2),
        },
        {
          label: "Transaction Currency",
          key: "currency",
          formatter: (_, row) => row.currency.name,
        },
        {
          label: "Debit",
          key: "debit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Credit",
          key: "credit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        { label: "Transaction Status", key: "status" },
        { label: "Gateway Status", key: "gateway_status" },
      ];
    }
    if (
      transactionTableData != null &&
      selectedAccounts.length == 1 &&
      !selectedAccounts.includes("ALL")
    ) {
      headerDashboardFinal = [
        {
          label: "Date & Time",
          key: "date",
          formatter: (val) => formatDateTransaction(val),
        },
        { label: "Transaction ID", key: "reference_code" },
        {
          label: "From Account",
          key: "account_name",
          formatter: (_, row) => {
            if (row.mode == "deposit") {
              return row.bank?.account_name || "";
            } else {
              if (
                row.mode == "withdrawal_rtgs" ||
                row.mode == "withdrawal_international" ||
                row.mode == "withdrawal"
              ) {
                return row.to_account?.name || "";
              }
              if (row.mode == "transfer") {
                return row.from_account?.name || "";
              }
            }
          },
        },
        {
          label: "To Account",
          key: "account_name",
          formatter: (_, row) => {
            if (row.mode == "deposit" || row.mode == "transfer") {
              return row.to_account?.name || "";
            } else {
              if (
                row.mode == "withdrawal_rtgs" ||
                row.mode == "withdrawal_international" ||
                row.mode == "withdrawal"
              ) {
                return row.bank?.account_name || "";
              }
            }
          },
        },
        {
          label: "Convert Rate",
          key: "convert_rate",
          formatter: (val) => val.toFixed(2),
        },
        {
          label: "Transaction Currency",
          key: "currency",
          formatter: (_, row) => row.currency.name,
        },
        {
          label: "Debit",
          key: "debit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Credit",
          key: "credit",
          formatter: (val) =>
            val
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        {
          label: "Running Balance",
          key: "balance",
          formatter: (val) =>
            "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        },
        { label: "Transaction Status", key: "status" },
        { label: "Gateway Status", key: "gateway_status" },
      ];
    }
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, headerDashboardFinal);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8" />
                <style>
                @page {
          size: A4 landscape;
          margin: 0;
        }
          html, body {
                  margin: 0;
                  padding: 0;
                            font-family:sans-serif;
          overflow: auto;  /* Ensure content can overflow */
        
                  height: 100%; /* Ensure the body fills the entire height */
                }        .pdf-container {
                    max-width: 100% !important;
                    margin: 20px;
                  }
                  tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
          
                  .custom-header {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding-top: 10px; /* Ensures no padding at the top */
                  }
          
                  .logo-container {
                    display: flex;
                    align-items: center;
                  }
          
                  .logo {
                    width: 96px; /* Tailwind w-24 = 6rem = 96px */
                    max-width: 150px;
                    height: auto;
                    object-fit: contain;
                    margin-right: 1rem;
                  }
          
                  .title {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 1.125rem; /* Tailwind text-lg */
                    font-weight: 500;    /* Tailwind font-medium */
                    padding: 0;          /* Remove any padding */
                    margin: 0;           /* Remove any margin */
                  }
          
                  .date {
                    font-size: 0.875rem;  /* Tailwind text-sm */
                    font-weight: 500;
                    color: #000000;
                    padding-bottom: 16px;
                  }
        
          
        .page-break {
                 page-break-before: always;
          break-before: page;
          display: block;
          height: 0; /* No extra space */
          width: 100%;
          content: "";}
              table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }
        
            thead {
              font-size: 10px;
              color: #6B7280; /* Tailwind text-labelColour equivalent */
            }
        
            th {
              border-bottom: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
                  td {
              padding: 6px;
              font-size: 10px;
              vertical-align: middle;
              text-align: left;
            }
              .tbody-tr{
                          background-color: #F9F9F9;
                          margin-bottom: 10px;
        
              }
                </style>
              </head>
              <body>
             <div class="pdf-container">
                <div class="custom-header">
                  <div class="logo-container">
                    <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                  </div>
                  <h2 class="title">Transaction History</h2>
                  <div class="date">${date}</div>
                </div>
                
          <table id="dynamic-table">
          ${tableHeader}
            ${tableBody}
        
          </table>
            
              </div> 
        
                   </body>
            </html>
          `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Transaction History-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTable(false);
    setIsOpenDownloadReport(false);
  };
  useEffect(() => {
    if (isHiddenTable == true) {
      handleDownloadPDFTable();
    }
  }, [isHiddenTable]);

  const [localStorageData, setLocalStorageData] = useState({}); // ✅ define state

  useEffect(() => {
    const STORAGE_KEY = "caprock-local";
    const js = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");

    if (
      typeof js !== "undefined" &&
      typeof js["access-token"] !== "undefined"
    ) {
      setLocalStorageData(js);
    } else {
      // window.localStorage.removeItem(STORAGE_KEY);
      // Redirect to sign-in (implement navigation logic)
      console.log("Redirect to sign-in");
    }
  }, []);

  // Add these missing state variables after line 277 (after alerts state)
  const [dashboard, setDashboard] = useState(null);
  const [yearChartValues, setYearChartValues] = useState([]);
  const [chart1, setChart1] = useState([]);
  const [chart2, setChart2] = useState([]);
  const [chart3, setChart3] = useState([]);
  const [chart4, setChart4] = useState([]);
  const [chart5, setChart5] = useState([]);
  const [onChart, setOnChart] = useState(1);

  return (
    <div className="pt-4  lg:min-w-[79vw] lg:max-w-[80vw]">
      {isLoadingCard ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <CustomCardSlider
          componentName="dashboard"
          cardData={cardDatanew}
          defaultCard={defaultCard}
          ondefaultCard={(value) => setDefaultCard(value)}
        />
      )}

      {defaultCard.id == 1 && (
        <div className="mt-1">
          {loading && (
            <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
              <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}
          <div className={`p-4 shadow-md rounded-md bg-[#8DAAE8]`}>
            <div className="flex justify-between items-center border-b border-colour-custom px-4 text-white">
              {/* Left side: Icon and heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/cash-account.svg"
                  alt="User Avatar"
                  className="h-6 w-6 mb-2"
                />
                <h1 className="text-xl font-medium mb-2">
                  Cash Account Portfolio
                </h1>
              </div>

              {/* Right side: Add Stocks button */}
              <button
                onClick={togglePopupAddAccount}
                className="text-sm mb-2 flex items-center text-black bg-white border-2 border-black py-2 px-3 rounded-full"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                <span className="font-medium text-sm">Add Account</span>
              </button>
            </div>

            {isOpenAccount && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[70vh] max-h-screen overflow-y-auto">
                  {/* Modal Header */}
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Add New Cash Account
                      </h2>
                      <div className="flex justify-end">
                        <img
                          onClick={togglePopupAddAccount}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        {/* Code */}
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Account Name
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newAccountName}
                            onChange={(e) => setNewAccountName(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John Doe"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Description
                          </label>{" "}
                          <textarea
                            id="finInstituition"
                            type="text"
                            value={accountDescription}
                            onChange={(e) =>
                              setAccountDescription(e.target.value)
                            }
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Add text.."
                          />
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div className="">
                          <Dropdown
                            label="Currency"
                            options={currencyData}
                            search={true}
                            preselectedValue={preselectedcashCurrency}
                            onSelect={handleSelectToCurrency}
                            colorLabel=""
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Account Balance
                          </label>{" "}
                          <input
                            type="text"
                            name="field2"
                            value={
                              isFocusedAccountBalance
                                ? accountBalance
                                : formatNumber(accountBalance)
                            }
                            ref={inputRefAccountBalance}
                            onChange={(e) => {
                              if (!isFocusedAccountBalance) return;
                              handleChangeAmountBalance(e, e.target.value);
                            }}
                            onFocus={() => setIsFocusedAccountBalance(true)}
                            onBlur={() => setIsFocusedAccountBalance(false)}
                            className="rounded-md border border-gray-300 p-2 w-full text-black font-medium outline-none text-md"
                          />
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4 px-4 pt-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Fees
                          </label>
                          <input
                            type="text"
                            name="field2"
                            value={
                              isFocusedAccountFee
                                ? minimumInvestment
                                : formatNumber(minimumInvestment)
                            }
                            ref={inputRefAccountFee}
                            onChange={(e) => {
                              if (!isFocusedAccountFee) return;
                              handleChangeAmountFee(e, e.target.value);
                            }}
                            onFocus={() => setIsFocusedAccountFee(true)}
                            onBlur={() => setIsFocusedAccountFee(false)}
                            className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Fee Buffer Amount
                          </label>
                          <input
                            type="text"
                            name="field2"
                            value={
                              isFocusedAccountFeeBuffer
                                ? bufferAmount
                                : formatNumber(bufferAmount)
                            }
                            ref={inputRefAccountFeeBuffer}
                            onChange={(e) => {
                              if (!isFocusedAccountFeeBuffer) return;
                              handleChangeAmountFeeBuffer(e, e.target.value);
                            }}
                            onFocus={() => setIsFocusedFeeBuffer(true)}
                            onBlur={() => setIsFocusedFeeBuffer(false)}
                            className="rounded-md bg-white  border border-gray-300  p-2 w-full text-black font-medium outline-none text-md"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                      <button
                        onClick={togglePopupAddAccount}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            !newAccountName ||
                            !toCurrency ||
                            !accountBalance ||
                            !minimumInvestment ||
                            !bufferAmount ||
                            !accountDescription
                          ) {
                            showToast("Please Add all fields", "error");
                            return;
                          }
                          setLoading(true);
                          handleAddCashAccount(e);
                        }}
                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                      >
                        Add Account
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="grid mt-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {cashAccountData.map((account) => (
                <div
                  key={account.id}
                  className="border p-4 rounded-md shadow-md relative"
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-sm text-white font-semibold">
                        Account {account.id}
                      </h3>
                    </div>
                    <div className="relative">
                      <button
                        ref={(el) => (buttonRefs.current[`${account.id}`] = el)}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleDropdownAccount(account.id);
                        }}
                        className="text-lg font-bold focus:outline-none"
                      >
                        ⋮
                      </button>
                      {activeDropdownId === account.id && (
                        <div className="absolute top-full right-0 mt-2 bg-white border border-gray-300 rounded-md shadow-lg text-sm z-50">
                          {accountOptions.map((option) => (
                            <button
                              key={option}
                              onClick={() => {
                                setLoading(true);

                                handleOptionClick(option, account.id);
                              }}
                              className="block w-40 px-4 py-2 hover:bg-black hover:text-white text-left"
                            >
                              {option}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                    {/* Left Column */}
                    <div className="space-y-4">
                      <div>
                        <div className="flex items-center space-x-2">
                          <p className="text-xs text-white">Account Name</p>
                          <img
                            onClick={(e) => handleEditClick(e, account)}
                            src="/edit-details.svg"
                            alt="Edit Icon"
                            className="w-3 h-3 cursor-pointer"
                          />
                        </div>
                        <p className="text-sm font-medium">{account.name}</p>
                      </div>

                      <div>
                        <p className="text-xs text-white">Account Number</p>
                        <p className="text-sm font-medium">
                          {account.account_number}
                        </p>
                      </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4">
                      <div>
                        <p className="text-xs text-white">Currency</p>
                        <p className="text-sm font-medium">
                          {account.currency.name}
                        </p>
                      </div>

                      <div>
                        <p className="text-xs text-white">Account Balance</p>
                        <p className="text-sm font-medium">
                          {account.balance
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </p>
                      </div>
                    </div>
                  </div>
                  {isClientPopupOpen === account.id && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg w-[90%] md:w-[500px] p-6">
                        {/* Modal Header */}
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Add Pay ID
                          </h2>
                          <button onClick={() => toggleClientPop(account.id)}>
                            <img
                              src="/add.svg"
                              alt="Close"
                              className="w-10 h-10"
                            />
                          </button>
                        </div>

                        {/* Modal Body */}
                        <div className="grid grid-cols-1 gap-6 items-center">
                          <div className="space-y-4 mx-auto ">
                            <div className="mb-4 relative">
                              <label
                                htmlFor="password"
                                className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                              >
                                Enter Pay ID
                              </label>
                              <input
                                type="text"
                                value={payId}
                                required={true}
                                id="currentpassword"
                                onChange={(e) => setPayId(e.target.value)}
                                className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                                placeholder="Pay Id"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="flex justify-center space-x-4 mt-6">
                          <button
                            onClick={() => toggleClientPop(account.id)}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (!payId) {
                                showToast("Please enter pay ID", "error");
                                return;
                              }
                              // setLoading(true);
                              ///  handleUpdateHinNumber(e, account.id);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="flex items-center justify-between mt-4">
                    {/* Left: Download Buttons */}
                    <div
                      ref={DownloadAccountRef}
                      className="relative mt-4 sm:mt-0"
                    >
                      <button
                        onClick={() => toggleDownloadDropdown(account.id)}
                        className="flex items-center gap-2 font-medium bg-white text-black border border-gray-300 px-3 py-1.5 rounded-xl shadow-sm hover:bg-gray-100 text-sm"
                      >
                        Download Report
                        <svg
                          className="w-4 h-4 ml-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>

                      {isDownloadOpen === account.id && (
                        <div className="absolute left-0 mt-2 w-38 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
                          <button
                            onClick={() => handleDownload(account.id, "pdf")}
                            className="rounded-xl w-full text-left px-4 py-2 hover:bg-black hover:text-white text-sm text-black"
                          >
                            Download PDF
                          </button>
                          <button
                            onClick={() => handleDownload(account.id, "excel")}
                            className="rounded-xl w-full text-left px-4 py-2 hover:bg-black hover:text-white text-sm text-black"
                          >
                            Download Excel
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Right: Tooltip Icon */}
                    <div
                      className="relative flex items-center ml-auto"
                      onMouseEnter={() => setTooltipVisible(account.id)}
                      onMouseLeave={() => setTooltipVisible(null)}
                    >
                      <button>
                        <img
                          src={
                            tooltipVisible === account.id
                              ? "/tooltip-white.svg"
                              : "/tooltip-black.svg"
                          }
                          alt="Tooltip Icon"
                          className="h-4 w-4"
                        />
                      </button>

                      {tooltipVisible === account.id && (
                        <div className="font-medium absolute bottom-full right-0 mb-2 bg-white text-xs p-2 rounded shadow-lg z-50">
                          <div className="relative">
                            <span className="text-[#888888]">
                              Type:{" "}
                              <span className="text-[#595959]">
                                Cash Account
                              </span>
                            </span>
                            <br />
                            <span className="text-[#888888]">
                              Created:{" "}
                              <span className="text-[#595959]">
                                {formatDateList(account.date_created)}{" "}
                              </span>
                            </span>
                            <div className="absolute -bottom-2 right-1 w-3 h-2 bg-white transform rotate-45"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {isModalOpenAccountEdit && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[60vh] max-h-screen overflow-y-auto">
                  {/* Modal Header */}
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Edit Account Details
                      </h2>
                      <div className="flex justify-end">
                        <img
                          onClick={() => {
                            setcurrentAccount(null);
                            setIsModalOpenAccountEdit(false);
                          }}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="grid px-4 grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        {/* Code */}
                        <div>
                          <label
                            htmlFor="acccountName"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Account Name
                          </label>{" "}
                          <input
                            id="acccountName"
                            type="text"
                            value={acccountName}
                            onChange={(e) => setAccountName(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John Doe"
                          />
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y- lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l border-gray-300 px-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Description
                          </label>{" "}
                          <textarea
                            id="finInstituition"
                            type="text"
                            value={accountDescription}
                            onChange={(e) =>
                              setAccountDescription(e.target.value)
                            }
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Add text.."
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                      <button
                        onClick={() => {
                          setcurrentAccount(null);
                          setIsModalOpenAccountEdit(false);
                        }}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (!acccountName) {
                            showToast("Account name is required", "error");
                            return;
                          }
                          setLoading(true);
                          handleEditAccount(e);
                        }}
                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                      >
                        Update Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="pt-4 lg:flex mb-4 lg:space-x-4 gap-4">
            {/* Left Section: Two Cards */}
            <div className="flex flex-col flex-[1.5] space-y-4">
              {/* Total Deposit Card */}
              <div className="bg-white p-6 rounded-lg shadow-md w-full flex-1">
                <div className="flex justify-between border-b  items-start">
                  <div className="flex items-center pb-2 space-x-4">
                    <img
                      src="/money-add.svg"
                      alt="Account Icon"
                      className="w-5 h-5 rounded-full"
                    />
                    <h3 className="text-black text-lg font-medium">
                      Total Deposit
                    </h3>
                  </div>
                  <span className="text-sm text-black pt-1">
                    <span className="text-sm text-[#A6A6A6]">Date: </span>
                    {getCurrentMonthYear()}
                  </span>
                </div>
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
                  {/* Active Accounts Section */}
                  <div className="text-sm text-gray-500 pt-4 flex-1 pb-4 sm:border-b-0 sm:border-r border-gray-300 pr-4">
                    <div className="flex text-xs justify-between items-center mb-2 sm:mb-0">
                      <p className="text-[#A6A6A6]">{cardCurrencyName.label}</p>
                    </div>
                    <div className="font-medium text-gray-800">
                      {cardCurrencyName.symbol}
                      {totalDepositData?.overall
                        ? totalDepositData.overall
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </div>
                  </div>

                  {/* Portfolio Section */}
                  <div className="text-sm text-gray-500 pt-4 pl-0 md:pl-4 lg:pl-4 flex-1 pb-4 sm:border-b-0 border-gray-300 pr-4">
                    <div className="flex justify-between items-center mb-2 sm:mb-0">
                      <p className="text-[#A6A6A6] text-xs">
                        {totalDepositData.this_month?.month
                          ? totalDepositData.this_month.month
                          : getCurrentMonthYear()}
                        ,{" "}
                        {totalDepositData.this_month?.year
                          ? totalDepositData.this_month.year
                          : ""}
                      </p>
                    </div>
                    <div className="font-medium text-black">
                      {cardCurrencyName.symbol}
                      {totalDepositData.this_month?.total_amount
                        ? totalDepositData.this_month.total_amount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </div>
                  </div>
                </div>
              </div>

              {/* Total Withdrawal Card */}
              <div className="bg-white p-6 rounded-lg shadow-md w-full flex-1">
                <div className="flex justify-between border-b  items-start">
                  <div className="flex items-center pb-2 space-x-4">
                    <img
                      src="/money-add.svg"
                      alt="Account Icon"
                      className="w-5 h-5 rounded-full"
                    />
                    <h3 className="text-black text-lg font-medium">
                      Total Withdrawal
                    </h3>
                  </div>
                  <span className="text-sm text-black pt-1">
                    <span className="text-sm text-[#A6A6A6]">Date: </span>
                    {getCurrentMonthYear()}
                  </span>
                </div>
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
                  {/* Active Accounts Section */}
                  <div className="text-sm text-gray-500 pt-4 flex-1 pb-4 sm:border-b-0 sm:border-r border-gray-300 pr-4">
                    <div className="flex text-xs justify-between items-center mb-2 sm:mb-0">
                      <p className="text-[#A6A6A6]">{cardCurrencyName.label}</p>
                    </div>
                    <div className="font-medium text-gray-800">
                      {cardCurrencyName.symbol}
                      {totalWithdrawData?.overall
                        ? totalWithdrawData.overall
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </div>
                  </div>

                  {/* Portfolio Section */}
                  <div className="text-sm text-gray-500 pt-4 pl-0 md:pl-4 lg:pl-4 flex-1 pb-4 sm:border-b-0 border-gray-300 pr-4">
                    <div className="flex justify-between items-center mb-2 sm:mb-0">
                      <p className="text-[#A6A6A6] text-xs">
                        {totalWithdrawData.this_month?.month
                          ? totalWithdrawData.this_month.month
                          : getCurrentMonthYear()}
                        ,{" "}
                        {totalWithdrawData.this_month?.year
                          ? totalWithdrawData.this_month.year
                          : ""}
                      </p>
                    </div>
                    <div className="font-medium text-black">
                      {cardCurrencyName.symbol}
                      {totalWithdrawData.this_month?.total_amount
                        ? totalWithdrawData.this_month.total_amount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section: Account Balance */}
            <div className="bg-white p-6 rounded-lg shadow-lg w-full lg:flex-[2.1]  border border-gray-200 flex-1">
              {/* Top Section with Date */}
              <div className="flex justify-between border-b  items-start">
                <div className="flex items-center pb-2 space-x-4">
                  <img
                    src="/archive.svg"
                    alt="Account Icon"
                    className="w-5 h-5 rounded-full"
                  />
                  <h3 className="text-black text-lg font-medium">
                    Account Balance
                  </h3>
                </div>
                <span className="text-sm text-black pt-1">
                  <span className="text-sm text-[#A6A6A6]">Date: </span>
                  {getCurrentMonthYear()}
                </span>{" "}
              </div>

              {/* Title, Active Accounts, and Additional Elements */}
              <div className="flex flex-col font-medium sm:flex-row items-start border-b sm:items-center justify-between gap-4 sm:gap-0">
                {/* Active Accounts Section */}
                <div className="text-sm text-gray-500 pt-4 flex-1 pb-4 sm:border-b-0 sm:border-r border-gray-300 pr-4">
                  <div className="flex justify-between items-center mb-2 sm:mb-0">
                    <p className="text-[#A6A6A6]">Active Accounts</p>
                    <span className="text-xs text-[#005A9C] font-medium px-1 py-1 rounded-full">
                      {balanceData.sub_account_change}%
                    </span>
                  </div>
                  <div className="font-medium text-gray-800">
                    {balanceData.active_sub_accounts}
                  </div>
                </div>

                {/* Portfolio Section */}
                <div className="text-sm text-gray-500 pt-4 pl-0 md:pl-4 lg:pl-4 flex-1 pb-4 sm:border-b-0 border-gray-300 pr-4">
                  <div className="flex justify-between items-center mb-2 sm:mb-0">
                    <p className="text-[#A6A6A6]">Portfolio</p>
                    <span className="text-xs font-medium text-[#005A9C] px-1 py-1 rounded-full">
                      {balanceData?.balance_change
                        ? balanceData.balance_change
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </span>
                  </div>
                  <div className="font-medium text-gray-800">
                    {cardCurrencyName.symbol}
                    {balanceData?.total_balance
                      ? balanceData.total_balance
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0.00"}
                  </div>
                </div>
              </div>

              {/* Graph Section */}
              <div className="w-full h-64 border-t pt-4">
                <div className="h-full w-full">
                  <canvas
                    className="h-full w-full min-w-full"
                    ref={chartRef}
                  ></canvas>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white mt-4 p-4 shadow-md rounded-md">
            <div className="">
              <div className="mb-4 flex flex-wrap justify-between items-center"></div>
              <div className="mb-4 flex flex-wrap items-center justify-between">
                <div className="flex text-sm md:text-md">
                  {["1M", "3M", "6M", "1Y", "All"].map((filter, index) => (
                    <button
                      key={filter}
                      className={`px-3 py-2 shadow-md ${
                        filter === "All" ? "rounded-r-xl" : ""
                      } ${filter === "1M" ? "rounded-l-xl" : ""} ${
                        selectedFilterTransaction === filter
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                      onClick={() => setSelectedFilterTransaction(filter)}
                    >
                      {filter}
                    </button>
                  ))}
                </div>

                <div className="mt-2 md:mt-0">
                  <button className="bg-white text-black pl-2 pr-6 py-1 h-10 whitespace-nowrap border-gray-300 border rounded-lg flex items-center">
                    <img
                      src="/presention-chart.svg" // Replace with the actual path to your image
                      alt="Graph Icon"
                      className="h-5 w-5 mr-2" // Adjust size and spacing as needed
                    />
                    Generate Graph
                  </button>
                </div>
              </div>
              {isLoadingGraph ? (
                <div className="shimmer-container-list mb-4 ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(2)].map((_, rowIndex) => (
                    <div key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(2)].map((_, colIndex) => (
                        <div key={colIndex} className="shimmer-cell-list h-20">
                          <div className="shimmer-loader"></div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ width: "100%", height: "400px" }}>
                  <Line data={dataLine} options={optionsLine} />
                </div>
              )}
            </div>
          </div>
          {filter == "transaction" && (
            <div className="bg-white mt-2 p-4 px-4 shadow-md rounded-md">
              <div className="flex flex-col gap-4 mb-4 border-b pb-5 border-gray-100 lg:flex-row lg:justify-between lg:items-start">
                {/* Left: Heading */}
                <div className="flex items-center">
                  <span className="font-medium lg:text-xl text-sm">
                    Transactions History
                  </span>
                </div>

                {/* Right: Actions */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3">
                  {/* Add Transaction Button */}
                  <button
                    onClick={(e) => {
                      getBankAccountData();
                      getThirdPartyBankAccountData();
                      setTransactionTab("addTransaction");
                      clearAllFields();
                      togglePopupAddTransaction();
                    }}
                    className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 lg:px-4 px-1 rounded-xl"
                  >
                    <img src="/Plus.svg" alt="Add Icon" className="mr-2 ml-2" />
                    <span className="inline">Add Transaction</span>
                  </button>

                  {/* Download Dropdown */}
                  <div
                    ref={DownloadRef}
                    className="relative inline-block mt-2 sm:mt-0"
                  >
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() =>
                        setIsOpenDownloadReport(!isOpenDownloadReport)
                      }
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2 ml-auto"
                      />
                    </div>

                    {isOpenDownloadReport && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {options.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDFTable(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              {isOpenEdit && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 mb-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex flex-wrap items-center justify-between mb-6 text-sm md:text-base">
                      <div className="flex items-center space-x-2 md:space-x-4">
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            clearAllFields();
                            setTransactionTab("addTransaction");
                          }}
                          className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                            transactionTab === "addTransaction"
                              ? "border-black text-black border-b-2"
                              : "text-gray-500 hover:text-black"
                          }`}
                        >
                          Account Number
                        </span>

                        <span className="hidden md:block text-[#B2B2B2]">
                          |
                        </span>
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            clearAllFieldsBank();
                            setTransactionTab("addBank");
                          }}
                          className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                            transactionTab === "addBank"
                              ? "border-black text-black border-b-2"
                              : "text-gray-500 hover:text-black"
                          }`}
                        >
                          Add External Bank
                        </span>
                        <span className="hidden md:block text-[#B2B2B2]">
                          |
                        </span>
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            clearAllFieldsBank();
                            setTransactionTab("addThirdPartyBank");
                          }}
                          className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                            transactionTab === "addThirdPartyBank"
                              ? "border-black text-black border-b-2"
                              : "text-gray-500 hover:text-black"
                          }`}
                        >
                          Add Third Party Bank
                        </span>
                      </div>
                      <div className="flex justify-end">
                        <img
                          onClick={togglePopupAddTransaction}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>

                    {transactionTab === "addTransaction" && (
                      <div>
                        {summaryDetails === false && (
                          <div>
                            <div className="flex items-center justify-between">
                              <h2 className="text-lg font-medium text-center w-full">
                                Add New Transaction
                              </h2>
                            </div>
                            <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                              <h1 className="text-md font-medium mb-2 text-center">
                                Transaction Details
                              </h1>
                            </div>{" "}
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-2">
                                <div className="">
                                  <Dropdown
                                    label="Transaction Type"
                                    options={transactionType}
                                    preselectedValue={
                                      preselectedTransactionType
                                    }
                                    onSelect={handleTransactionType}
                                  />
                                </div>
                                {transactionTypeValue == "debit" && (
                                  <div className="">
                                    <Dropdown
                                      label="RTGS/International/Normal"
                                      options={transactionTypeSecond}
                                      preselectedValue={
                                        preselectedTransactionTypeSecond
                                      }
                                      onSelect={handleTransactionTypeSecond}
                                    />
                                  </div>
                                )}
                                <div>
                                  <label
                                    htmlFor="accbalance"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Fees
                                  </label>{" "}
                                  <input
                                    id="accbalance"
                                    type="text"
                                    value={nabFees}
                                    disabled={true}
                                    className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="CT0291288"
                                  />
                                  <div className="flex items-center space-x-2 mt-4">
                                    <input
                                      type="checkbox"
                                      id="confirm-all"
                                      className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                                      checked={isCheckedSecond}
                                      onChange={(e) =>
                                        setIsCheckedSecond(e.target.checked)
                                      }
                                    />
                                    <label
                                      htmlFor="confirm-all"
                                      className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                                    >
                                      I accept the applicable fees.
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div className="">
                                  <Dropdown
                                    label="Set Recurrence"
                                    options={recurringTypes}
                                    preselectedValue={preselectedRecurringType}
                                    onSelect={handleRecurringType}
                                  />
                                </div>
                                {recurringTypeValue != "never" && (
                                  <>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Start Date
                                      </label>
                                      <input
                                        type="date"
                                        value={recStartDate}
                                        onChange={(e) => {
                                          const newStart = e.target.value;
                                          setRecStartDate(newStart);

                                          // Auto-clear end date if it becomes invalid
                                          if (
                                            recEndDate &&
                                            recEndDate < newStart
                                          ) {
                                            setRecEndDate("");
                                          }
                                        }}
                                        min={getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        End Date
                                      </label>
                                      <input
                                        type="date"
                                        value={recEndDate}
                                        onChange={(e) =>
                                          setRecEndDate(e.target.value)
                                        }
                                        min={recStartDate || getCurrentDate()}
                                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                      />
                                    </div>
                                  </>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 md:pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transaction Description
                                  </label>{" "}
                                  <textarea
                                    type="text"
                                    name="documentId"
                                    value={comments}
                                    maxLength={18}
                                    onChange={(e) =>
                                      setComments(e.target.value)
                                    }
                                    className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                    placeholder="Add your comments"
                                  />
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-xs text-labelColour"
                                  >
                                    You can enter only up to 18 characters.
                                  </label>{" "}
                                </div>
                                <div>
                                  <label className="block mb-1 w-full text-sm text-labelColour">
                                    Transaction Date
                                  </label>
                                  <input
                                    type="date"
                                    value={creationDate}
                                    onChange={(e) =>
                                      setCreationDate(e.target.value)
                                    }
                                    min={getCurrentDate()}
                                    className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                  />
                                </div>
                                <div>
                                  <label
                                    htmlFor="amount"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Amount
                                  </label>{" "}
                                  <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                    <span className="px-2 text-gray-500 font-medium">
                                      $
                                    </span>
                                    <input
                                      type="text"
                                      name="field2"
                                      value={
                                        isFocused
                                          ? transactionAmount
                                          : formatNumber(transactionAmount)
                                      }
                                      ref={inputRef}
                                      onChange={(e) => {
                                        if (!isFocused) return;
                                        handleChangeAmount(e, e.target.value);
                                      }}
                                      onFocus={() => setIsFocused(true)}
                                      onBlur={() => setIsFocused(false)}
                                      className="p-2 w-full text-black font-medium outline-none text-md"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {((transactionTypeValue == "debit" &&
                              transactionTypeValueSecond == "rtgs" &&
                              RTGSAllowed) ||
                              (transactionTypeValue == "debit" &&
                                transactionTypeValueSecond != "rtgs") ||
                              transactionTypeValue == "credit" ||
                              transactionTypeValue == "transfer") && (
                              <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                <img
                                  src="/warning-circle.svg"
                                  alt="Info"
                                  className="w-4 h-4 mr-2"
                                />
                                <span>
                                  Your transaction will appear in the system
                                  within next <strong>24 hours</strong>.
                                </span>
                              </div>
                            )}
                            {transactionTypeValue == "debit" &&
                              transactionTypeValueSecond == "rtgs" &&
                              !RTGSAllowed && (
                                <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                  <img
                                    src="/danger.svg"
                                    alt="Info"
                                    className="w-4 h-4 mr-2"
                                  />
                                  <span>
                                    <span>
                                      RTGS requests are accepted between{" "}
                                      <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                    </span>
                                  </span>
                                </div>
                              )}
                            {((transactionTypeValue == "debit" &&
                              transactionTypeValueSecond == "rtgs" &&
                              RTGSAllowed) ||
                              (transactionTypeValue == "debit" &&
                                transactionTypeValueSecond != "rtgs") ||
                              transactionTypeValue == "credit" ||
                              transactionTypeValue == "transfer") && (
                              <>
                                <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    From
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-4">
                                    <div className="">
                                      {transactionTypeValue == "debit" && (
                                        <Dropdown
                                          label="Select Cash Account"
                                          options={cashAccountForPopup}
                                          preselectedValue={
                                            preselectedcashAccount
                                          }
                                          search={true}
                                          onSelect={handleChangeCashAccount}
                                        />
                                      )}
                                      {transactionTypeValue != "debit" && (
                                        <>
                                          <Dropdown
                                            label="Select Bank Type"
                                            options={bankType}
                                            preselectedValue={
                                              preselectedBankType
                                            }
                                            onSelect={handleChangeBankType}
                                          />
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={fromCurrencyName}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="AUD"
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l  md:border-r  border-gray-300 px-4">
                                    {transactionTypeValue != "debit" &&
                                      bankTypeValue == 1 && (
                                        <Dropdown
                                          label="Select External Bank Account"
                                          options={bankAccountData}
                                          preselectedValue={
                                            preselectedcashAccount
                                          }
                                          search={true}
                                          onSelect={handleChangeCashAccount}
                                        />
                                      )}
                                    {transactionTypeValue != "debit" &&
                                      bankTypeValue == 2 && (
                                        <Dropdown
                                          label="Select Third Party Bank Account"
                                          options={thirdPartyBankAccountData}
                                          preselectedValue={
                                            preselectedcashAccount
                                          }
                                          search={true}
                                          onSelect={handleChangeCashAccount}
                                        />
                                      )}
                                    {transactionTypeValue == "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={fromAccountNumber}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue != "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={fromAccountNumber}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Currency
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={fromCurrencyName}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="AUD"
                                        />
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" &&
                                      transactionTypeValueSecond ==
                                        "international" && (
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 mt-4 text-sm text-labelColour"
                                          >
                                            Currency Rate
                                          </label>{" "}
                                          <input
                                            id="accbalance"
                                            type="text"
                                            value="1.00"
                                            disabled={true}
                                            className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                            placeholder="AUD"
                                          />
                                        </div>
                                      )}
                                  </div>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    To
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-4">
                                    <div className="">
                                      {transactionTypeValue == "debit" && (
                                        <>
                                          <Dropdown
                                            label="Select Bank Type"
                                            options={bankType}
                                            preselectedValue={
                                              preselectedBankType
                                            }
                                            onSelect={handleChangeBankType}
                                          />
                                          <div>
                                            <label
                                              htmlFor="accbalance"
                                              className="mb-1 mt-4 text-sm text-labelColour"
                                            >
                                              Currency
                                            </label>{" "}
                                            <input
                                              id="accbalance"
                                              type="text"
                                              value={toCurrencyName}
                                              disabled={true}
                                              className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                              placeholder="CT0291288"
                                            />
                                          </div>
                                        </>
                                      )}
                                      {transactionTypeValue != "debit" && (
                                        <Dropdown
                                          label="Select Cash Account"
                                          options={cashAccountForPopup}
                                          preselectedValue={
                                            preselectedToAccount
                                          }
                                          onSelect={handleChangeToAccount}
                                          search={true}
                                        />
                                      )}
                                    </div>
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                    {transactionTypeValue == "debit" &&
                                      bankTypeValue == 1 && (
                                        <Dropdown
                                          label="Select External Bank Account"
                                          options={bankAccountData}
                                          preselectedValue={
                                            preselectedToAccount
                                          }
                                          onSelect={handleChangeToAccount}
                                          search={true}
                                        />
                                      )}
                                    {transactionTypeValue == "debit" &&
                                      bankTypeValue == 2 && (
                                        <Dropdown
                                          label="Select Third Party Bank Account"
                                          options={thirdPartyBankAccountData}
                                          preselectedValue={
                                            preselectedToAccount
                                          }
                                          onSelect={handleChangeToAccount}
                                          search={true}
                                        />
                                      )}
                                    {transactionTypeValue != "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={toAccountNumberTransaction}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" &&
                                      transactionTypeValueSecond ==
                                        "international" && (
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 mt-4 text-sm text-labelColour"
                                          >
                                            Currency Rate
                                          </label>{" "}
                                          <input
                                            id="accbalance"
                                            type="text"
                                            value={finalConvertedRate}
                                            disabled={true}
                                            className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                            placeholder="AUD"
                                          />
                                        </div>
                                      )}
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue == "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={toAccountNumberTransaction}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                    )}
                                    {transactionTypeValue != "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Currency
                                        </label>{" "}
                                        <input
                                          id="accbalance"
                                          type="text"
                                          value={toCurrencyName}
                                          disabled={true}
                                          className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                          placeholder="CT0291288"
                                        />
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" &&
                                      transactionTypeValueSecond ==
                                        "international" &&
                                      fromCurrencyName != toCurrencyName && (
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 mt-4 text-sm text-labelColour"
                                          >
                                            Final Converted Amount
                                          </label>{" "}
                                          <input
                                            id="accbalance"
                                            type="text"
                                            value={
                                              isFocusedFinal
                                                ? finalConvertedAmount
                                                : formatNumber(
                                                    finalConvertedAmount
                                                  )
                                            }
                                            ref={inputRefFinal}
                                            onChange={(e) => {
                                              if (!isFocusedFinal) return;
                                              handleChangeAmountFinal(
                                                e,
                                                e.target.value
                                              );
                                            }}
                                            onFocus={() =>
                                              setIsFocusedFinal(true)
                                            }
                                            onBlur={() =>
                                              setIsFocusedFinal(false)
                                            }
                                            className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                            placeholder="100.00"
                                          />
                                        </div>
                                      )}
                                  </div>
                                </div>
                                {/* Modal Footer */}
                                <div className="flex justify-center space-x-4 mt-10">
                                  <button
                                    onClick={togglePopupAddTransaction}
                                    className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (!transactionAmount) {
                                        showToast(
                                          "Please Add valid amount",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!toAccountId) {
                                        showToast(
                                          "Please Select To Account",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!fromAccountId) {
                                        showToast(
                                          "Please Select From Account",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!creationDate) {
                                        showToast(
                                          "Please Select Transaction Date",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (
                                        recurringTypeValue != "never" &&
                                        !recStartDate
                                      ) {
                                        showToast(
                                          "Please select a recurrence start date.",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (
                                        recurringTypeValue != "never" &&
                                        !recEndDate
                                      ) {
                                        showToast(
                                          "Please select a recurrence end date.",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (!comments) {
                                        showToast(
                                          "Please Add some description",
                                          "error"
                                        );
                                        return;
                                      }
                                      if (isCheckedSecond == false) {
                                        showToast(
                                          "Please confirm applicable fees",
                                          "error"
                                        ); // Success toast
                                        return;
                                      }
                                      setSummaryDetails(true);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                  >
                                    Next
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                        {summaryDetails === true && (
                          <div>
                            <div className="flex items-center justify-between">
                              <h2 className="text-lg font-medium text-center w-full">
                                Transaction Summary
                              </h2>
                            </div>
                            <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                              <h1 className="text-md font-medium mb-2 text-center">
                                Transaction Details
                              </h1>
                            </div>{" "}
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-2">
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Transaction Type
                                </label>{" "}
                                <span>{transactionTypeName}</span>
                                {transactionTypeValue == "debit" && (
                                  <div className="">
                                    <label
                                      htmlFor="finInstituition"
                                      className="mb-1 text-sm text-labelColour"
                                    >
                                      RTGS/International/Normal
                                    </label>{" "}
                                    <span>{transactionTypeNameSecond}</span>
                                  </div>
                                )}
                                <div className="">
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Fees
                                  </label>{" "}
                                  <span>{nabFees}</span>
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div>
                                  <label
                                    htmlFor="Recurring Frequency"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Recurring Frequency
                                  </label>{" "}
                                  <span>{recurringTypeLabel}</span>
                                </div>
                                {recurringTypeValue != "never" && (
                                  <>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        Start Date
                                      </label>
                                      <span>
                                        {formatDateForFilterNew(recStartDate)}
                                      </span>
                                    </div>
                                    <div>
                                      <label className="block mb-1 w-full text-sm text-labelColour">
                                        End Date
                                      </label>
                                      <span>
                                        {formatDateForFilterNew(recEndDate)}
                                      </span>
                                    </div>
                                  </>
                                )}
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 md:pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transaction Description
                                  </label>{" "}
                                  <span>{comments}</span>
                                </div>
                                <div>
                                  <label className="block mb-1 w-full text-sm text-labelColour">
                                    Transaction Date
                                  </label>

                                  <span>
                                    {formatDateForFilterNew(creationDate)}
                                  </span>
                                </div>
                                <div>
                                  <label
                                    htmlFor="amount"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Amount
                                  </label>{" "}
                                  <div className="flex items-center">
                                    <span>
                                      $
                                      {Number(transactionAmount)
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {((transactionTypeValue == "debit" &&
                              transactionTypeValueSecond == "rtgs" &&
                              RTGSAllowed) ||
                              (transactionTypeValue == "debit" &&
                                transactionTypeValueSecond != "rtgs") ||
                              transactionTypeValue == "credit" ||
                              transactionTypeValue == "transfer") && (
                              <div className=" mt-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
                                <img
                                  src="/warning-circle.svg"
                                  alt="Info"
                                  className="w-4 h-4 mr-2"
                                />
                                <span>
                                  Your transaction will appear in the system
                                  within next <strong>24 hours</strong>.
                                </span>
                              </div>
                            )}
                            {transactionTypeValue == "debit" &&
                              transactionTypeValueSecond == "rtgs" &&
                              !RTGSAllowed && (
                                <div className=" mt-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
                                  <img
                                    src="/danger.svg"
                                    alt="Info"
                                    className="w-4 h-4 mr-2"
                                  />
                                  <span>
                                    <span>
                                      RTGS requests are accepted between{" "}
                                      <strong>9:00 AM – 3:00 PM</strong>.{" "}
                                    </span>
                                  </span>
                                </div>
                              )}
                            {((transactionTypeValue == "debit" &&
                              transactionTypeValueSecond == "rtgs" &&
                              RTGSAllowed) ||
                              (transactionTypeValue == "debit" &&
                                transactionTypeValueSecond != "rtgs") ||
                              transactionTypeValue == "credit" ||
                              transactionTypeValue == "transfer") && (
                              <>
                                <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    From
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-0">
                                    <div className="">
                                      <label
                                        htmlFor="accbalance"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        {transactionTypeValue == "debit"
                                          ? "Selected Cash Account"
                                          : "Selected Bank Type"}
                                      </label>{" "}
                                      <span>
                                        {" "}
                                        {transactionTypeValue == "debit"
                                          ? fromAccountName
                                          : bankTypeLabel}
                                      </span>
                                    </div>
                                    {transactionTypeValue != "debit" && (
                                      <div className="mt-4">
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Currency
                                        </label>{" "}
                                        <span> {fromCurrencyName}</span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                    {transactionTypeValue != "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Selected Account
                                        </label>{" "}
                                        <span>{fromAccountName}</span>
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <span>{fromAccountNumber}</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue != "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <span>{fromAccountNumber}</span>
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" && (
                                      <div className="">
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Currency
                                        </label>{" "}
                                        <span> {fromCurrencyName}</span>
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" &&
                                      transactionTypeValueSecond ==
                                        "international" && (
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Currency Rate
                                          </label>{" "}
                                          <span>1.00</span>
                                        </div>
                                      )}
                                  </div>
                                </div>
                                <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                                  <h1 className="text-md font-medium mb-2 text-center">
                                    To
                                  </h1>
                                </div>{" "}
                                <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                                  {/* Left Column */}
                                  <div className="space-y-4 pt-4 px-0">
                                    <div className="">
                                      <label
                                        htmlFor="accbalance"
                                        className="mb-1 text-sm text-labelColour"
                                      >
                                        {transactionTypeValue == "debit"
                                          ? "Selected Bank Type"
                                          : "Selected Cash Account"}
                                      </label>{" "}
                                      <span>
                                        {" "}
                                        {transactionTypeValue == "debit"
                                          ? bankTypeLabel
                                          : toAccountNameTrans}
                                      </span>
                                    </div>
                                    {transactionTypeValue == "debit" && (
                                      <div className="mt-4">
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Currency
                                        </label>{" "}
                                        <span> {toCurrencyName}</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Center Column with Border */}
                                  <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r  border-gray-300 px-4">
                                    {transactionTypeValue == "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Selected Account
                                        </label>{" "}
                                        <span>{toAccountNameTrans}</span>
                                      </div>
                                    )}
                                    {transactionTypeValue != "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <span>
                                          {toAccountNumberTransaction}
                                        </span>
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" &&
                                      transactionTypeValueSecond ==
                                        "international" && (
                                        <div>
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Currency Rate
                                          </label>{" "}
                                          <span>{finalConvertedRate}</span>
                                        </div>
                                      )}
                                  </div>

                                  {/* Right Column */}
                                  <div className="space-y-4 px-4 md:pt-4">
                                    {transactionTypeValue == "debit" && (
                                      <div>
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Account Number
                                        </label>{" "}
                                        <span>
                                          {toAccountNumberTransaction}
                                        </span>
                                      </div>
                                    )}
                                    {transactionTypeValue != "debit" && (
                                      <div className="mt-4">
                                        <label
                                          htmlFor="accbalance"
                                          className="mb-1 text-sm text-labelColour"
                                        >
                                          Currency
                                        </label>{" "}
                                        <span> {toCurrencyName}</span>
                                      </div>
                                    )}
                                    {transactionTypeValue == "debit" &&
                                      transactionTypeValueSecond ==
                                        "international" &&
                                      fromCurrencyName != toCurrencyName && (
                                        <div className="mt-4">
                                          <label
                                            htmlFor="accbalance"
                                            className="mb-1 text-sm text-labelColour"
                                          >
                                            Final Converted Amount
                                          </label>{" "}
                                          <span>
                                            {Number(finalConvertedAmount)
                                              .toFixed(2)
                                              .toString()
                                              .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ","
                                              )}
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                </div>
                                {/* Modal Footer */}
                                <div className="flex justify-center space-x-4 mt-10">
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setSummaryDetails(false);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                                  >
                                    Back
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setLoading(true);
                                      handleAddTransacion(e);
                                    }}
                                    className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                                  >
                                    Transfer Now
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    {transactionTab === "payId" && (
                      <div>
                        {summaryDetailsPayID === false && (
                          <div>
                            <div className="flex items-center justify-between">
                              <h2 className="text-lg font-medium text-center w-full">
                                Pay Easily Using Pay ID{" "}
                              </h2>
                            </div>
                            <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                              <h1 className="text-md font-medium mb-2 text-center">
                                Transaction Details
                              </h1>
                            </div>{" "}
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-2">
                                <div>
                                  {" "}
                                  <label
                                    htmlFor="accbalance"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Pay ID
                                  </label>{" "}
                                  <input
                                    id="accbalance"
                                    type="text"
                                    value={userPayId}
                                    onChange={(e) =>
                                      setUserPayID(e.target.value)
                                    }
                                    className="border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="Enter Pay ID here"
                                  />
                                </div>
                                <div>
                                  <label className="block mb-1 mt-4 w-full text-sm text-labelColour">
                                    Transaction Date
                                  </label>
                                  <input
                                    type="date"
                                    value={creationDate}
                                    onChange={(e) =>
                                      setCreationDate(e.target.value)
                                    }
                                    min={getCurrentDate()}
                                    className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                                  />
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div>
                                  <label
                                    htmlFor="amount"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Amount
                                  </label>{" "}
                                  <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                                    <span className="px-2 text-gray-500 font-medium">
                                      $
                                    </span>
                                    <input
                                      type="text"
                                      name="field2"
                                      value={
                                        isFocusedPayID
                                          ? transactionAmountPayID
                                          : formatNumber(transactionAmountPayID)
                                      }
                                      ref={inputRefPayID}
                                      onChange={(e) => {
                                        if (!isFocusedPayID) return;
                                        handleChangeAmountPayID(
                                          e,
                                          e.target.value
                                        );
                                      }}
                                      onFocus={() => setIsFocusedPayID(true)}
                                      onBlur={() => setIsFocusedPayID(false)}
                                      className="p-2 w-full text-black font-medium outline-none text-md"
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 md:pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transaction Description
                                  </label>{" "}
                                  <textarea
                                    type="text"
                                    name="documentId"
                                    value={commentsPayID}
                                    maxLength={18}
                                    onChange={(e) =>
                                      setCommentsPayID(e.target.value)
                                    }
                                    className="w-full border resize-none bg-white text-black rounded-xl px-3 py-4"
                                    placeholder="Add your comments"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-10">
                              <button
                                onClick={togglePopupAddTransaction}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!transactionAmountPayID) {
                                    showToast(
                                      "Please Add valid amount",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (!userPayId) {
                                    showToast("Please enter Pay ID", "error");
                                    return;
                                  }
                                  if (!creationDate) {
                                    showToast(
                                      "Please Select Transaction Date",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (!commentsPayID) {
                                    showToast(
                                      "Please Add some description",
                                      "error"
                                    );
                                    return;
                                  }
                                  setSummaryDetailsPayID(true);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        )}
                        {summaryDetailsPayID === true && (
                          <div>
                            <div className="flex items-center justify-between">
                              <h2 className="text-lg font-medium text-center w-full">
                                Transaction Summary
                              </h2>
                            </div>
                            <div className="flex mt-2 items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                              <h1 className="text-md font-medium mb-2 text-center">
                                Transaction Details
                              </h1>
                            </div>{" "}
                            <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                              {/* Left Column */}
                              <div className="space-y-4 pt-4 px-2">
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Pay ID
                                </label>{" "}
                                <span>{userPayId}</span>
                                <div className="">
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transaction Date
                                  </label>{" "}
                                  <span>
                                    {" "}
                                    {formatDateForFilterNew(creationDate)}
                                  </span>
                                </div>
                              </div>

                              {/* Center Column with Border */}
                              <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                                <div>
                                  <label
                                    htmlFor="Recurring Frequency"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Amount
                                  </label>{" "}
                                  <span>
                                    $
                                    {Number(transactionAmountPayID)
                                      .toFixed(2)
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </span>
                                </div>
                              </div>

                              {/* Right Column */}
                              <div className="space-y-4 px-4 md:pt-4">
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transaction Description
                                  </label>{" "}
                                  <span>{commentsPayID}</span>
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-center space-x-4 mt-10">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSummaryDetailsPayID(false);
                                }}
                                className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                              >
                                Back
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  // setLoading(true);
                                  //handleAddTransacion(e);
                                }}
                                className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                              >
                                Transfer Now
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {transactionTab === "addBank" && (
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Add New External Bank
                          </h2>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={togglePopupAddTransaction}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter a valid routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleAddBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Add Bank
                          </button>
                        </div>
                      </div>
                    )}
                    {transactionTab === "addThirdPartyBank" && (
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h2 className="text-lg font-medium text-center w-full">
                            Add New Third Party Bank
                          </h2>
                        </div>
                        <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Left Column */}
                          <div className="space-y-4 pt-4 px-4">
                            {/* Code */}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Account Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toAccountName}
                                onChange={(e) =>
                                  setToAccountName(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="John Doe"
                              />
                            </div>
                            {countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) && (
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Account Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={toAccountNumber}
                                    onChange={(e) =>
                                      setToAccountNumber(e.target.value)
                                    }
                                    className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="0291288"
                                  />
                                </div>
                              )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Bank Name
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBank}
                                onChange={(e) => setToBank(e.target.value)}
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Bank Name"
                              />
                            </div>
                          </div>

                          {/* Center Column with Border */}
                          <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="">
                              <Dropdown
                                label="Select Country"
                                options={countryCodeData}
                                search={true}
                                preselectedValue={preselectedCountryCode}
                                onSelect={handleSelectCountryCode}
                                colorLabel=""
                              />
                            </div>
                            <div className="">
                              <Dropdown
                                label="Currency"
                                options={currencyData}
                                search={true}
                                preselectedValue={preselectedcashCurrency}
                                onSelect={handleSelectToCurrency}
                                colorLabel=""
                              />
                            </div>
                            {countryCode == "AU" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  BSB
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toBsb}
                                  maxLength={6}
                                  onChange={(e) =>
                                    handleBsbChange(e.target.value)
                                  }
                                  className={`${
                                    bsbError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000"
                                />
                                {bsbError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {bsbError}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Swift/BIC code
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={swiftCode}
                                onChange={handleSwiftChange}
                                className={`${
                                  swiftError && countryCode != "AU"
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && countryCode != "AU" && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
                            </div>
                            {countryCode == "US" && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Routing Number (ABA)
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={routingNumber}
                                  maxLength={9}
                                  onChange={(e) =>
                                    handleRoutingChange(e.target.value)
                                  }
                                  className={`${
                                    routingError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="000000000"
                                />
                                {routingError && (
                                  <p className="text-red-600 text-sm mt-1">
                                    {routingError}
                                  </p>
                                )}
                              </div>
                            )}
                            {countryCode == "CA" && (
                              <>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Transit Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={transitNumber}
                                    maxLength={5}
                                    onChange={(e) =>
                                      handleTransitChange(e.target.value)
                                    }
                                    className={`${
                                      transitError
                                        ? "border-red-300 "
                                        : "border-gray-300 "
                                    }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                    placeholder="00000"
                                  />
                                  {transitError && (
                                    <p className="text-red-600 text-xs mt-1">
                                      {transitError}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  <label
                                    htmlFor="finInstituition"
                                    className="mb-1 text-sm text-labelColour"
                                  >
                                    Institution Number
                                  </label>{" "}
                                  <input
                                    id="finInstituition"
                                    type="text"
                                    value={institutionNumber}
                                    onChange={(e) =>
                                      setinstitutionNumber(e.target.value)
                                    }
                                    className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                    placeholder="000000"
                                  />
                                </div>
                              </>
                            )}
                            {(countryCode == "AE" ||
                              countryCode == "GB" ||
                              isEuropeanCountry(countryCode)) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  IBAN
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={iban}
                                  onChange={handleChangeIban}
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                                {error && (
                                  <p className="text-red-500 text-sm mt-1">
                                    {error}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="space-y-4 px-4 pt-4">
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 1
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine1}
                                onChange={(e) =>
                                  setAddressLine1(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Street address"
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 2
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine2}
                                onChange={(e) =>
                                  setAddressLine2(e.target.value)
                                }
                                className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="Apartment, unit etc."
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Address Line 3
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={addressLine3}
                                onChange={(e) =>
                                  setAddressLine3(e.target.value)
                                }
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="City, Country etc."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                          <button
                            onClick={togglePopupAddTransaction}
                            className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              if (countryCode == "AU" && (!toBsb || bsbError)) {
                                showToast("Please enter a valid BSB", "error");
                                return;
                              }
                              if (
                                countryCode == "US" &&
                                (!routingNumber || routingError)
                              ) {
                                showToast(
                                  "Please enter a valid routing number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                (countryCode == "AE" ||
                                  countryCode == "GB" ||
                                  isEuropeanCountry(countryCode)) &&
                                !iban
                              ) {
                                showToast("Please enter iban", "error");
                                return;
                              }
                              if (
                                countryCode == "CA" &&
                                (!transitNumber || transitError)
                              ) {
                                showToast(
                                  "Please enter a valid transit number",
                                  "error"
                                );
                                return;
                              }
                              if (countryCode == "CA" && !institutionNumber) {
                                showToast(
                                  "Please enter institution number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                countryCode != "AU" &&
                                (!swiftCode || swiftError)
                              ) {
                                showToast(
                                  "Please enter a valid swift code/BIC code",
                                  "error"
                                );
                                return;
                              }
                              if (error) {
                                showToast("Please enter valid iban", "error");
                                return;
                              }
                              if (
                                countryCode != "AE" &&
                                countryCode != "GB" &&
                                !isEuropeanCountry(countryCode) &&
                                !toAccountNumber
                              ) {
                                showToast(
                                  "Please enter account number",
                                  "error"
                                );
                                return;
                              }
                              if (
                                !toAccountName ||
                                !toCurrency ||
                                !addressLine1 ||
                                !addressLine2 ||
                                !addressLine3 ||
                                !countryCode ||
                                !toBank
                              ) {
                                showToast("Please Add all fields", "error");
                                return;
                              }
                              setLoading(true);
                              handleAddBank(e);
                            }}
                            className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                          >
                            Add Bank
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {isOpenOTP && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[600px] p-2 mt-4 mb-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex  flex-col mt-4 justify-center items-center md:p-0 p-4 justify">
                      <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                        Please Verify your Mobile Number
                      </h2>
                      <form
                        className="w-full max-w-sm"
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (otp.length < 6) {
                            showToast("Please Enter 6 digit OTP!", "error"); // Success toast
                            return;
                          }
                          setLoading(true);
                          handleSubmitMobile(e);
                        }}
                      >
                        <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                          Please check your Mobile for the verification code we
                          just sent you and enter the code in the box below
                        </p>
                        <div className="mb-2">
                          <label
                            htmlFor="maskedData"
                            className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                          >
                            Code sent to:
                          </label>
                          <input
                            id="maskedData"
                            name="maskedData"
                            type="text"
                            value={mobileNumber}
                            required={true}
                            disabled={true}
                            className="input-field disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                          />
                        </div>
                        <div className="mb-4 mt-10">
                          <OTPInputWithTimer
                            onOtpChange={(value) => setOtp(value)}
                            onLoadingChange={(value) => setLoading(value)}
                            initialTime={300}
                            userId={userId}
                            postCode={SendCode}
                          />
                        </div>

                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (otp.length < 6) {
                              showToast("Please Enter 6 digit otp", "error");
                              return;
                            }
                            setLoading(true);
                            handleSendOtp(e);
                          }}
                          type="submit"
                          className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                        >
                          Submit
                        </button>
                      </form>
                      <div className="mt-2 w-full max-w-sm text-center">
                        <button
                          type="submit"
                          onClick={() => setIsOpenOTP(false)}
                          className="w-full dark:bg-[#101010] dark:text-white dark:border-[#424242] mt-2 signup-button text-black font-medium text-sm py-3 rounded flex items-center justify-center gap-2 hover:bg-[#F1F5F9] dark:hover:bg-[#1E293B]  transition duration-300"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!isOpenOTP && isOpenOTPEmail && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[600px] p-2 mt-4 mb-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex  flex-col mt-4 justify-center items-center md:p-0 p-4 justify">
                      <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                        Please Verify your Email Address
                      </h2>
                      <form
                        className="w-full max-w-sm"
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (otp.length < 6) {
                            showToast("Please Enter 6 digit OTP!", "error"); // Success toast
                            return;
                          }
                          setLoading(true);
                          handleSubmitMobile(e);
                        }}
                      >
                        <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                          Please check your inbox for the verification code we
                          just sent you and enter the code in the box below
                        </p>
                        <div className="mb-2">
                          <label
                            htmlFor="maskedData"
                            className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                          >
                            Code sent to:
                          </label>
                          <input
                            id="maskedData"
                            name="maskedData"
                            type="text"
                            value={email}
                            required={true}
                            disabled={true}
                            className="input-field disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                          />
                        </div>
                        <div className="mb-4 mt-10">
                          <OTPInputWithTimer
                            onOtpChange={(value) => setOtpEmail(value)}
                            onLoadingChange={(value) => setLoading(value)}
                            initialTime={300}
                            userId={userId}
                            postCode={SendCode}
                          />
                        </div>

                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (otpEmail.length < 6) {
                              showToast("Please Enter 6 digit otp", "error");
                              return;
                            }
                            setLoading(true);
                            handleSendOtpEmail(e);
                          }}
                          type="submit"
                          className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                        >
                          Submit
                        </button>
                      </form>
                      <div className="mt-2 w-full max-w-sm text-center">
                        <button
                          type="submit"
                          onClick={() => setIsOpenOTPEmail(false)}
                          className="w-full dark:bg-[#101010] dark:text-white dark:border-[#424242] mt-2 signup-button text-black font-medium text-sm py-3 rounded flex items-center justify-center gap-2 hover:bg-[#F1F5F9] dark:hover:bg-[#1E293B]  transition duration-300"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="p-4">
                {/* Filters Section */}
                <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                  <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                    <div className="flex items-center space-x-2">
                      <span className="lg:text-md  text-sm text-[#8C8C8C]">
                        Show Records
                      </span>
                      <Dropdown
                        label=""
                        options={filterOptions}
                        preselectedValue={preSelectedFilter}
                        onSelect={handleshowRecord}
                      />
                    </div>
                    <div className="flex items-center">
                      <div className="relative">
                        <input
                          type="text"
                          className="p-2 pl-8 border rounded-xl"
                          placeholder="Search Here"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <span className="absolute left-2 top-3 text-gray-500">
                          {" "}
                          <img
                            src="/search-normal.svg"
                            alt="Company Logo"
                            className="mr-2"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-0 md:space-x-4  flex  flex-col md:flex-row ">
                    <div
                      ref={DateCalendarRef}
                      className="flex items-center z-10 mt-4 md:mt-0 w-full space-x-4"
                    >
                      <div className="relative w-full">
                        {/* Dropdown Trigger */}
                        <div
                          className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                          onClick={toggleDropdown}
                        >
                          <span>{selectedRange}</span>
                          <img
                            src={
                              isDropdownOpen
                                ? "/open-dropdown.svg"
                                : "/download-small-arrow.svg"
                            }
                            alt="Dropdown Icon"
                            className="h-2 w-2 transition-transform duration-300 transform"
                          />
                        </div>

                        {/* Dropdown */}
                        {isDropdownOpen && (
                          <div className="absolute top-12 left-1/2 lg:left-1/4 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-80 w-[90vw] lg:w-[650px] max-h-[400px] overflow-auto">
                            <div className="flex  flex-col md:flex-row h-full">
                              {/* Left: Quick Filters */}
                              <div className="w-full md:w-1/3 border-r p-3 h-full">
                                {quickFilters.map((filter) => (
                                  <div
                                    key={filter.value}
                                    className={`p-2 cursor-pointer rounded ${
                                      quickFilter === filter.value
                                        ? "bg-black text-white"
                                        : "hover:bg-gray-200 text-black"
                                    } transition-all duration-200 ease-in-out`}
                                    onClick={() =>
                                      handleQuickFilter(filter.value)
                                    }
                                  >
                                    {filter.label}
                                  </div>
                                ))}
                              </div>

                              {/* Right: Calendar */}
                              <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                <Flatpickr
                                  key={selectedDates}
                                  options={{
                                    mode: "range",
                                    inline: true,
                                    dateFormat: "Y-m-d",
                                    showMonths: 2,
                                    defaultDate:
                                      selectedDates.length > 0
                                        ? selectedDates
                                        : [],
                                    shorthandCurrentMonth: true,
                                    locale: {
                                      firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                    },
                                    onChange: (dates) => {
                                      if (
                                        quickFilter === "custom" &&
                                        dates.length === 2
                                      ) {
                                        setSelectedDates(dates);
                                      }
                                    },
                                  }}
                                  className="w-full"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      ref={accountRef}
                      className="relative w-full mt-4 md:mt-0 md:w-full"
                    >
                      {/* Dropdown Button */}
                      <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="w-full  font-medium border-gray-300  rounded-xl text-sm  py-2 flex items-center justify-between focus:outline-none bg-white text-black"
                      >
                        <div className="flex items-center justify-between p-2 w-full md:w-40 border rounded-xl bg-white cursor-pointer">
                          {/* Dropdown Text */}
                          <span className="">
                            {selectedAccounts.length > 0 &&
                            selectedAccounts.includes("ALL")
                              ? "ALL"
                              : "Select Account"}
                          </span>
                          {/* Dropdown Icon */}
                          <img
                            src={
                              isOpen
                                ? "/open-dropdown.svg"
                                : "/download-small-arrow.svg"
                            }
                            alt="Dropdown Icon"
                            className="h-2 w-2 transition-transform duration-300 transform"
                          />
                        </div>
                      </button>

                      {/* Dropdown List */}
                      {isOpen && (
                        <div
                          className="absolute text-xs left-0 mt-2 overflow-y-auto mb-5 md:w-60 w-full bg-white border rounded-md shadow-lg z-50"
                          style={{
                            maxHeight: "200px", // Optional: limit height
                          }}
                        >
                          <div className="p-2">
                            <input
                              type="text"
                              value={searchAccount}
                              onChange={(e) => {
                                setCurrentPage(1);
                                setSearchAccount(e.target.value);
                              }}
                              placeholder="Search..."
                              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                            />
                          </div>
                          {AllAccount.filter((option) =>
                            option.label
                              .toLowerCase()
                              .includes(searchAccount.toLowerCase())
                          ).map((option) => (
                            <div
                              key={option.value}
                              className={`px-4 py-2 flex items-center cursor-pointer ${
                                selectedAccounts.includes(option.value)
                                  ? "text-white bg-black"
                                  : "text-black bg-white"
                              }`}
                            >
                              <input
                                type="checkbox"
                                checked={selectedAccounts.includes(
                                  option.value
                                )}
                                onChange={() => handleAccountListChange(option)}
                                className="custom-checkbox"
                              />
                              <span
                                onClick={() => handleAccountListChange(option)}
                                className="ml-2"
                              >
                                {option.label}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="relative w-full mt-4 md:mt-0 md:w-full flex items-center space-x-2">
                      {/* Clear All Button */}
                      <button
                        onClick={() => {
                          resetAllFilters();
                        }}
                        className="font-medium h-10 rounded-xl text-xs flex justify-center items-center focus:outline-none underline text-[#FF5050]"
                      >
                        Clear All
                      </button>

                      {/* Refresh Button */}
                      <button
                        onClick={() => {
                          getAllUserTransactions();
                        }}
                        className="font-medium h-10  rounded-xl text-xs flex justify-center items-center focus:outline-none  text-black"
                      >
                        <img
                          src="/refresh.svg"
                          alt="User Avatar"
                          className="h-4 w-4 ml-2"
                        />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Table */}
                {transactionTableData != null &&
                  (selectedAccounts.length > 1 ||
                    selectedAccounts.length == 0 ||
                    selectedAccounts.includes("ALL")) && (
                    <div className="overflow-x-auto">
                      <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                        <thead className="text-[#8C8C8C] text-sm">
                          <tr className="border border-[#EDEDED]">
                            {withOutheadersDashboard.map((header, index) => (
                              <th
                                key={header.label}
                                className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7 ||
                              index === 8 ||
                              index === 9
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 10
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                              >
                                <div className="flex items-center">
                                  <span>{header.label}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        </thead>

                        {isLoading ? (
                          <tbody className="shimmer-container-list ">
                            {/* Creating 5 rows of shimmer effect */}
                            {[...Array(5)].map((_, rowIndex) => (
                              <tr key={rowIndex} className="shimmer-row-list">
                                {/* Creating 7 cells in each row for shimmer */}
                                {[...Array(8)].map((_, colIndex) => (
                                  <td
                                    key={colIndex}
                                    className="shimmer-cell-list"
                                  >
                                    <div className="shimmer-loader"></div>
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        ) : (
                          <tbody className="text-sm font-medium text-black">
                            {transactionTableData.length > 0 ? (
                              transactionTableData.map((row, index) => (
                                <React.Fragment key={index}>
                                  <tr
                                    className={`cursor-pointer mb-2 ${
                                      expandedRow === row.id
                                        ? "bg-[#EBF3F8]"
                                        : "bg-[#F9F9F9]"
                                    }`}
                                  >
                                    <td className="px-4 py-2">
                                      <div className="flex items-center space-x-2">
                                        <img
                                          src="/clock.svg"
                                          alt="Time Icon"
                                          className="h-4 w-4"
                                        />
                                        <span className="rounded-xl">
                                          {`${formatDateTransaction(row.date)}`}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      {row.reference_code}
                                    </td>
                                    <td className="p-2">{row.account_name}</td>
                                    <td className="p-2">
                                      ${row.convert_rate.toFixed(2)}
                                    </td>
                                    <td className="p-2">{row.currency.name}</td>
                                    <td className="p-2  text-[#FF5050]">
                                      {row.currency.symbol}
                                      {row.debit
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="p-2  text-[#62D76E]">
                                      {row.currency.symbol}
                                      {row.credit
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>

                                    <td className="px-4 py-2 relative">
                                      {row.status}
                                    </td>
                                    <td className="px-4 py-2 relative">
                                      {row.gateway_status}
                                    </td>
                                    <td
                                      onClick={() => toggleRowDetails(row.id)}
                                      className="text-center rounded-r"
                                    >
                                      {expandedRow === row.id && (
                                        <img
                                          src="/expanded-black.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                      {expandedRow !== row.id && (
                                        <img
                                          src="/down-grey-steps.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                  {expandedRow === row.id && (
                                    <tr>
                                      <td
                                        colSpan={10}
                                        className="bg-[#EEF7FD] w-full"
                                      >
                                        <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4  md:pt-6">
                                              <label
                                                htmlFor="refId"
                                                className="mb-1 text-xs text-[#A6A6A6]"
                                              >
                                                From
                                              </label>
                                              <TooltipCustom
                                                nametext={
                                                  row.mode == "deposit"
                                                    ? `${row.bank.account_name}`
                                                    : row.mode ==
                                                        "withdrawal_rtgs" ||
                                                      row.mode ==
                                                        "withdrawal_international" ||
                                                      row.mode == "withdrawal"
                                                    ? `${row.to_account.name}`
                                                    : row.mode == "transfer"
                                                    ? `${row.from_account.name}`
                                                    : ""
                                                }
                                                numbertext={
                                                  row.mode == "deposit"
                                                    ? `${row.bank.account_number}`
                                                    : row.mode ==
                                                        "withdrawal_rtgs" ||
                                                      row.mode ==
                                                        "withdrawal_international" ||
                                                      row.mode == "withdrawal"
                                                    ? `${row.to_account.unique_id}`
                                                    : row.mode == "transfer"
                                                    ? `${row.from_account.unique_id}`
                                                    : ""
                                                }
                                                currencytext={
                                                  row.mode ==
                                                    "withdrawal_rtgs" ||
                                                  row.mode ==
                                                    "withdrawal_international" ||
                                                  row.mode == "withdrawal"
                                                    ? `${row.to_account.currency.name}`
                                                    : `${row.currency.name}`
                                                }
                                                amounttext={
                                                  row.mode ==
                                                    "withdrawal_rtgs" ||
                                                  row.mode ==
                                                    "withdrawal_international" ||
                                                  row.mode == "withdrawal"
                                                    ? `${row.to_account.currency.amount_in_currency}`
                                                    : ``
                                                }
                                              >
                                                <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                  {row.mode == "deposit"
                                                    ? `${row.bank.account_name}`
                                                    : row.mode ==
                                                        "withdrawal_rtgs" ||
                                                      row.mode ==
                                                        "withdrawal_international" ||
                                                      row.mode == "withdrawal"
                                                    ? `${row.to_account.name}`
                                                    : row.mode == "transfer"
                                                    ? `${row.from_account.name}`
                                                    : ""}
                                                </span>
                                              </TooltipCustom>

                                              <div className="mt-4"></div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Description
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.description}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    To
                                                  </span>
                                                </label>
                                                <TooltipCustom
                                                  nametext={
                                                    row.mode == "deposit" ||
                                                    row.mode == "transfer"
                                                      ? `${row.to_account.name}`
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode == "withdrawal"
                                                      ? `${row.bank.account_name}`
                                                      : ""
                                                  }
                                                  numbertext={
                                                    row.mode == "deposit" ||
                                                    row.mode == "transfer"
                                                      ? `${row.to_account.unique_id}`
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode == "withdrawal"
                                                      ? `${row.bank.account_number}`
                                                      : ""
                                                  }
                                                  currencytext={
                                                    row.mode ==
                                                      "withdrawal_rtgs" ||
                                                    row.mode ==
                                                      "withdrawal_international" ||
                                                    row.mode == "withdrawal"
                                                      ? `${row.bank.currency.name}`
                                                      : `${row.currency.name}`
                                                  }
                                                  amounttext={
                                                    row.mode ==
                                                      "withdrawal_rtgs" ||
                                                    row.mode ==
                                                      "withdrawal_international" ||
                                                    row.mode == "withdrawal"
                                                      ? `${row.bank.currency.amount_in_currency}`
                                                      : ``
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.mode == "deposit" ||
                                                    row.mode == "transfer"
                                                      ? `${row.to_account.name}`
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode == "withdrawal"
                                                      ? `${row.bank.account_name}`
                                                      : ""}
                                                  </span>
                                                </TooltipCustom>
                                              </div>
                                            </div>
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Ip address
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.ip_address}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4 md:pt-6">
                                              <div className="mt-4">
                                                <label
                                                  htmlFor="investmentType"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  Initiated by
                                                </label>
                                                <div className="text-sm">
                                                  {row.created_by}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                >
                                                  Signatories
                                                </label>
                                                <div className="text-sm">
                                                  <span>
                                                    {row.approved_by} (
                                                    {formatDateTransaction(
                                                      row.date
                                                    )}
                                                    )
                                                  </span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center py-4" colSpan="7">
                                  No results found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  )}
                {transactionTableData != null &&
                  selectedAccounts.length == 1 &&
                  !selectedAccounts.includes("ALL") && (
                    <div className="overflow-x-auto">
                      <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                        <thead className="text-[#8C8C8C] text-sm">
                          <tr className="border border-[#EDEDED]">
                            {headersDashboard.map((header, index) => (
                              <th
                                key={header.label}
                                className={`
                        cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1 ||
                              index === 2 ||
                              index === 3 ||
                              index === 4 ||
                              index === 5 ||
                              index === 6 ||
                              index === 7 ||
                              index === 8 ||
                              index === 9
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 10
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                              >
                                <div className="flex items-center">
                                  <span>{header.label}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        </thead>

                        {isLoading ? (
                          <tbody className="shimmer-container-list ">
                            {/* Creating 5 rows of shimmer effect */}
                            {[...Array(5)].map((_, rowIndex) => (
                              <tr key={rowIndex} className="shimmer-row-list">
                                {/* Creating 7 cells in each row for shimmer */}
                                {[...Array(9)].map((_, colIndex) => (
                                  <td
                                    key={colIndex}
                                    className="shimmer-cell-list"
                                  >
                                    <div className="shimmer-loader"></div>
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        ) : (
                          <tbody className="text-sm font-medium text-black">
                            {transactionTableData.length > 0 ? (
                              transactionTableData.map((row, index) => (
                                <React.Fragment key={index}>
                                  <tr
                                    className={`cursor-pointer mb-2 ${
                                      expandedRow === row.id
                                        ? "bg-[#EBF3F8]"
                                        : "bg-[#F9F9F9]"
                                    }`}
                                  >
                                    <td className="px-4 py-2">
                                      <div className="flex items-center space-x-2">
                                        <img
                                          src="/clock.svg"
                                          alt="Time Icon"
                                          className="h-4 w-4"
                                        />
                                        <span className="rounded-xl">
                                          {`${formatDateTransaction(row.date)}`}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      {row.reference_code}
                                    </td>
                                    <td className="p-2">{row.account_name}</td>
                                    <td className="p-2">
                                      {row.convert_rate.toFixed(2)}
                                    </td>
                                    <td className="p-2">{row.currency.name}</td>
                                    <td className="p-2  text-[#FF5050]">
                                      {row.currency.symbol}
                                      {row.debit
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="p-2  text-[#62D76E]">
                                      {row.currency.symbol}{" "}
                                      {row.credit
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="p-2">
                                      {row.balance
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td className="px-4 py-2 relative">
                                      {row.status}
                                    </td>
                                    <td className="px-4 py-2 relative">
                                      {row.gateway_status}
                                    </td>
                                    <td
                                      onClick={() => toggleRowDetails(row.id)}
                                      className="text-center rounded-r"
                                    >
                                      {expandedRow === row.id && (
                                        <img
                                          src="/expanded-black.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                      {expandedRow !== row.id && (
                                        <img
                                          src="/down-grey-steps.svg"
                                          alt="Star Icon"
                                          className="h-4 w-4 ml-2 ml-2 mb-1 inline-block"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                  {expandedRow === row.id && (
                                    <tr>
                                      <td
                                        colSpan={11}
                                        className="bg-[#EEF7FD] w-full"
                                      >
                                        <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid px-4 md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4  md:pt-6">
                                              <label
                                                htmlFor="refId"
                                                className="mb-1 text-xs text-[#A6A6A6]"
                                              >
                                                From
                                              </label>
                                              <TooltipCustom
                                                nametext={
                                                  row.mode == "deposit"
                                                    ? `${row.bank.account_name}`
                                                    : row.mode ==
                                                        "withdrawal_rtgs" ||
                                                      row.mode ==
                                                        "withdrawal_international" ||
                                                      row.mode == "withdrawal"
                                                    ? `${row.to_account.name}`
                                                    : row.mode == "transfer"
                                                    ? `${row.from_account.name}`
                                                    : ""
                                                }
                                                numbertext={
                                                  row.mode == "deposit"
                                                    ? `${row.bank.account_number}`
                                                    : row.mode ==
                                                        "withdrawal_rtgs" ||
                                                      row.mode ==
                                                        "withdrawal_international" ||
                                                      row.mode == "withdrawal"
                                                    ? `${row.to_account.unique_id}`
                                                    : row.mode == "transfer"
                                                    ? `${row.from_account.unique_id}`
                                                    : ""
                                                }
                                                currencytext={
                                                  row.mode ==
                                                    "withdrawal_rtgs" ||
                                                  row.mode ==
                                                    "withdrawal_international" ||
                                                  row.mode == "withdrawal"
                                                    ? `${row.to_account.currency.name}`
                                                    : `${row.currency.name}`
                                                }
                                                amounttext={
                                                  row.mode ==
                                                    "withdrawal_rtgs" ||
                                                  row.mode ==
                                                    "withdrawal_international" ||
                                                  row.mode == "withdrawal"
                                                    ? `${row.to_account.currency.amount_in_currency}`
                                                    : ``
                                                }
                                              >
                                                <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                  {row.mode == "deposit"
                                                    ? `${row.bank.account_name}`
                                                    : row.mode ==
                                                        "withdrawal_rtgs" ||
                                                      row.mode ==
                                                        "withdrawal_international" ||
                                                      row.mode == "withdrawal"
                                                    ? `${row.to_account.name}`
                                                    : row.mode == "transfer"
                                                    ? `${row.from_account.name}`
                                                    : ""}
                                                </span>
                                              </TooltipCustom>

                                              <div className="mt-4"></div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Description
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.description}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    To
                                                  </span>
                                                </label>
                                                <TooltipCustom
                                                  nametext={
                                                    row.mode == "deposit" ||
                                                    row.mode == "transfer"
                                                      ? `${row.to_account.name}`
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode == "withdrawal"
                                                      ? `${row.bank.account_name}`
                                                      : ""
                                                  }
                                                  numbertext={
                                                    row.mode == "deposit" ||
                                                    row.mode == "transfer"
                                                      ? `${row.to_account.unique_id}`
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode == "withdrawal"
                                                      ? `${row.bank.account_number}`
                                                      : ""
                                                  }
                                                  currencytext={
                                                    row.mode ==
                                                      "withdrawal_rtgs" ||
                                                    row.mode ==
                                                      "withdrawal_international" ||
                                                    row.mode == "withdrawal"
                                                      ? `${row.bank.currency.name}`
                                                      : `${row.currency.name}`
                                                  }
                                                  amounttext={
                                                    row.mode ==
                                                      "withdrawal_rtgs" ||
                                                    row.mode ==
                                                      "withdrawal_international" ||
                                                    row.mode == "withdrawal"
                                                      ? `${row.bank.currency.amount_in_currency}`
                                                      : ``
                                                  }
                                                >
                                                  <span className="text-sm text-[#3047EC] underline cursor-pointer">
                                                    {row.mode == "deposit" ||
                                                    row.mode == "transfer"
                                                      ? `${row.to_account.name}`
                                                      : row.mode ==
                                                          "withdrawal_rtgs" ||
                                                        row.mode ==
                                                          "withdrawal_international" ||
                                                        row.mode == "withdrawal"
                                                      ? `${row.bank.account_name}`
                                                      : ""}
                                                  </span>
                                                </TooltipCustom>
                                              </div>
                                            </div>
                                            <div className="flex flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 text-xs"
                                                >
                                                  <span className="text-[#A6A6A6]">
                                                    Ip address
                                                  </span>
                                                </label>
                                                <div className="text-sm">
                                                  {row.ip_address}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex px-4 flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
                                          {/* Profile Details */}
                                          <div className="grid md:border-b grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                                            {/* Column 1 */}
                                            <div className="flex flex-col md:px-4 md:pt-6">
                                              <div className="mt-4">
                                                <label
                                                  htmlFor="investmentType"
                                                  className="mb-1 text-xs text-[#A6A6A6]"
                                                >
                                                  Initiated by
                                                </label>
                                                <div className="text-sm">
                                                  {row.created_by}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 2 */}
                                            <div className="flex pb-4 flex-col md:px-0 md:pt-6">
                                              <div className="md:border-l md:pl-4">
                                                <label
                                                  htmlFor="investmentManagerFees"
                                                  className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                                                >
                                                  Signatories
                                                </label>
                                                <div className="text-sm">
                                                  <span>
                                                    {row.approved_by} (
                                                    {formatDateTransaction(
                                                      row.date
                                                    )}
                                                    )
                                                  </span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Column 3 */}
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                            <div className="flex flex-col md:px-0 md:pt-6"></div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center py-4" colSpan="7">
                                  No results found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  )}
                {transactionTableData != null && (
                  <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                    {/* Entries Info Section */}
                    <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                      Showing {showRecords * (currentPage - 1) + 1} to{" "}
                      {currentPage === totalPages || totalPages == 0
                        ? totalCount
                        : Math.max(
                            showRecords * currentPage,
                            transactionTableData.length
                          )}{" "}
                      of {totalCount} entries
                    </div>

                    {/* Pagination Section */}
                    <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                      {/* Previous Button */}
                      <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => prev - 1)}
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Prev
                      </button>

                      {/* Page Buttons */}
                      {Array.from({ length: Math.min(totalPages, 5) }).map(
                        (_, index) => {
                          const startPage = Math.max(
                            1,
                            Math.min(totalPages - 4, currentPage - 2)
                          );
                          const page = startPage + index;

                          return (
                            <button
                              key={page}
                              onClick={() => setCurrentPage(page)}
                              className={`px-3 py-1 rounded ${
                                currentPage === page
                                  ? "bg-black text-white"
                                  : "bg-white border border-gray-300 text-black"
                              }`}
                            >
                              {page}
                            </button>
                          );
                        }
                      )}

                      {/* Next Button */}
                      <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((prev) => prev + 1)}
                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      {defaultCard.id == 2 && (
        <div>
          {/* <div className="pt-4 pr-4 flex-wrap items-center">
            <div className="flex mb-2">
              <button
                onClick={() => {
                  setFilter("accounts");
                }}
                className={`px-4 py-2 text-sm lg:w-auto rounded-l-xl border-r border-gray-100 ${
                  filter === "accounts"
                    ? "bg-black text-white"
                    : "bg-white text-black"
                }`}
              >
                Accounts
              </button>
              <button
                onClick={() => {
                  setFilter("purchase_product");
                }}
                className={`lg:px-4 px-2 py-2 text-sm border-r border-gray-100 ${
                  filter === "purchase_product"
                    ? "bg-black text-white"
                    : "bg-white text-black"
                }`}
              >
                Purchase Products
              </button>
              <button
                onClick={() => {
                  setFilter("trading");
                }}
                className={`px-4 py-2 text-sm border-r border-gray-100 ${
                  filter === "trading"
                    ? "bg-black text-white"
                    : "bg-white text-black"
                }`}
              >
                Trading
              </button>
              <button
                onClick={() => {
                  setFilter("transaction_history");
                }}
                className={`px-4 py-2 text-sm rounded-r-xl ${
                  filter === "transaction_history"
                    ? "bg-black text-white"
                    : "bg-white text-black"
                }`}
              >
                Transaction History
              </button>
            </div>
          </div> */}
          <div className="pt-4 flex  justify-between gap-4 flex-col lg:flex-row">
            <div className="lg:flex  lg:w-[70vw] investment-width-left w-full">
              <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
                <h2 className="text-lg font-bold">Portfolio List</h2>
                <div className="w-full">
                  <Dropdown
                    label="Select Portfolio"
                    options={investmentList}
                    preselectedValue={preSelectedStrategyType}
                    onSelect={handleSelectStrategyType}
                  />
                </div>
                {isLoadingDetails ? (
                  <div className="shimmer-container-list mb-4 ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(1)].map((_, rowIndex) => (
                      <div key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(2)].map((_, colIndex) => (
                          <div
                            key={colIndex}
                            className="shimmer-cell-list h-20"
                          >
                            <div className="shimmer-loader "></div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2 md:gap-4 font-semibold mt-4  text-sm">
                      <div className="bg-[#3047EC] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[2px]">
                        <span className="text-sm font-semibold">
                          Total Invested
                        </span>
                        <span className="text-[#3047EC] text-sm font-semibold">
                          {cardCurrencyName.symbol}
                          {totalInvested
                            ? totalInvested
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </span>
                      </div>
                      <div className="bg-[#62D76E] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[2px]">
                        <div>
                          <Dropdown
                            label="Change in Balance"
                            options={balanceChanges}
                            preselectedValue={preSelectedBalanceChanges}
                            onSelect={handleBalanceChangesChange}
                            font="small"
                            colorLabel="text-black"
                          />
                        </div>
                        {balanceChangeFilterValue == "1M" && (
                          <>
                            {totalInvestedDetails &&
                              totalInvestedDetails.monthly < 0 && (
                                <span className="text-[#FF5050] text-sm font-semibold">
                                  -{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.monthly
                                    ? Math.abs(totalInvestedDetails.monthly)
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                            {totalInvestedDetails &&
                              totalInvestedDetails.monthly >= 0 && (
                                <span className="text-[#34C046] text-sm font-semibold">
                                  +{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.monthly
                                    ? totalInvestedDetails.monthly
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                          </>
                        )}
                        {balanceChangeFilterValue == "All" && (
                          <>
                            {totalInvestedDetails &&
                              totalInvestedDetails.all_time < 0 && (
                                <span className="text-[#FF5050] text-sm font-semibold">
                                  -{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.all_time
                                    ? Math.abs(totalInvestedDetails.all_time)
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                            {totalInvestedDetails &&
                              totalInvestedDetails.all_time >= 0 && (
                                <span className="text-[#34C046] text-sm font-semibold">
                                  +{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.all_time
                                    ? totalInvestedDetails.all_time
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                          </>
                        )}
                        {balanceChangeFilterValue == "1Y" && (
                          <>
                            {totalInvestedDetails &&
                              totalInvestedDetails.yearly < 0 && (
                                <span className="text-[#FF5050] text-sm font-semibold">
                                  -{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.yearly
                                    ? Math.abs(totalInvestedDetails.yearly)
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                            {totalInvestedDetails &&
                              totalInvestedDetails.yearly >= 0 && (
                                <span className="text-[#34C046] text-sm font-semibold">
                                  +{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.yearly
                                    ? totalInvestedDetails.yearly
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                          </>
                        )}
                        {balanceChangeFilterValue == "1W" && (
                          <>
                            {totalInvestedDetails &&
                              totalInvestedDetails.weekly < 0 && (
                                <span className="text-[#FF5050] text-sm font-semibold">
                                  -{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.weekly
                                    ? Math.abs(totalInvestedDetails.weekly)
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                            {totalInvestedDetails &&
                              totalInvestedDetails.weekly >= 0 && (
                                <span className="text-[#34C046] text-sm font-semibold">
                                  +{cardCurrencyName.symbol}
                                  {totalInvestedDetails?.weekly
                                    ? totalInvestedDetails.weekly
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}{" "}
                                </span>
                              )}
                          </>
                        )}
                        {!totalInvestedDetails && (
                          <span className="text-[#34C046] text-sm font-semibold">
                            {cardCurrencyName.symbol}0.00
                          </span>
                        )}
                      </div>
                      {/* <div className="bg-[#62D76E] bg-opacity-20 px-4 py-2 rounded-lg flex flex-col leading-none space-y-[2px]">
                        <span className="text-[10px] font-semibold">
                          All-Time Change
                        </span>

                        {totalInvestedDetails &&
                          totalInvestedDetails.all_time_change < 0 && (
                            <span className="text-[#FF5050] text-sm font-semibold">
                              -${" "}
                              {totalInvestedDetails?.all_time_change
                                ? Math.abs(totalInvestedDetails.all_time_change)
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "0.00"}{" "}
                              (
                              {totalInvestedDetails?.all_time_change_percentage
                                ? Math.abs(
                                    totalInvestedDetails.all_time_change_percentage
                                  ).toFixed(2)
                                : "0.00"}
                              %)
                            </span>
                          )}
                        {totalInvestedDetails &&
                          totalInvestedDetails.all_time_change >= 0 && (
                            <span className="text-[#34C046] text-sm font-semibold">
                              +${" "}
                              {totalInvestedDetails?.all_time_change
                                ? totalInvestedDetails.all_time_change
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : "0.00"}{" "}
                              (
                              {totalInvestedDetails?.all_time_change_percentage
                                ? totalInvestedDetails.all_time_change_percentage.toFixed(
                                    2
                                  )
                                : "0.00"}
                              %)
                            </span>
                          )}
                        {!totalInvestedDetails && (
                          <span className="text-[#34C046] text-sm font-semibold">
                            $0.00
                          </span>
                        )}
                      </div> */}
                    </div>
                    <ReinvestProgressCard
                      investmentID={selectedInvestmentId}
                      totalAmount={totalDividend}
                      threshold={totalThreshold} // You can also get this from state or API
                    />
                  </>
                )}
                <div className="mb-4 mt-4 flex w-full justify-between flex-wrap">
                  <div className="pr-4 flex-wrap items-center">
                    <div className="flex">
                      {["All", "1Y", "1M", "1W"].map((filter, index) => (
                        <button
                          key={filter}
                          className={`px-3 py-1 text-sm shadow-md ${
                            filter === "1W" ? "rounded-r-xl" : ""
                          }
      ${filter === "All" ? "rounded-l-xl" : ""}
      ${
        selectedFilter === filter
          ? "bg-black font-bold text-white"
          : "bg-white text-black"
      }
      sm:px-2 sm:py-1`} // Added for responsiveness
                          onClick={() => {
                            setSelectedFilter(filter);
                            setBalanceChangeFilterValue(filter);
                            let preValue = balanceChanges.filter(
                              (item) => item.value == filter
                            );
                            setpreSelectedBalanceChanges(preValue[0]);
                          }}
                        >
                          {filter}
                        </button>
                      ))}
                    </div>
                  </div>
                  {/* Uncomment in future */}
                  {/* <div className="flex items-center text-sm mt-1 md:mt-0  space-x-1 ml-1 border px-1 py-1 rounded-md bg-white shadow-md">
                    <button
                      onClick={() => handleCustomTimeChange(-1)}
                      className="text-black"
                    >
                      <Minus size={14} />
                    </button>
                    <span className="text-xs font-medium">{customTime}H</span>
                    <button
                      onClick={() => handleCustomTimeChange(1)}
                      className="text-black"
                    >
                      <Plus size={14} />
                    </button>
                  </div> */}

                  {/* Flex container for image and performance text */}
                  <div className="flex flex-col mt-2 md:mt-0   md:flex-col items-start ml-auto space-x-0 space-y-0">
                    <div className="flex items-center">
                      <img
                        src="/growth-blue.svg"
                        alt="performance"
                        className="mr-2"
                      />
                      <span className="text-xs text-[#8C8C8C]">
                        Performance
                      </span>
                    </div>
                    <div className="flex items-center">
                      <img
                        src="/income-orange.svg"
                        alt="income-orange"
                        className="mr-2"
                      />
                      <span className="text-xs text-[#8C8C8C]">
                        Net Invested Amount
                      </span>
                    </div>
                  </div>
                </div>
                {isLoadingGraph ? (
                  <div className="shimmer-container-list mb-4 ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(1)].map((_, rowIndex) => (
                      <div key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(2)].map((_, colIndex) => (
                          <div
                            key={colIndex}
                            className="shimmer-cell-list h-20"
                          >
                            <div className="shimmer-loader "></div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="w-full" style={{ height: "400px" }}>
                    <MultiLineChart
                      graphData={performanceGraph}
                      selectedFilter={selectedFilter}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="w-full lg:w-[30vw] investment-width-right">
              <div className="flex  flex-col p-2 bg-white rounded-lg shadow-lg">
                <h2 className="text-lg font-semibold mb-2">
                  Investment Breakdown
                </h2>
                <div className="flex flex-col md:flex-nowrap md:flex-row md:items-start justify-between gap-4 w-full">
                  {/* Pie Chart */}
                  {breakdown && breakdown.length > 0 && (
                    <div className="flex justify-center w-full md:w-auto  flex-shrink-0">
                      <PieChart width={200} height={200}>
                        <Pie
                          data={breakdown}
                          cx="50%"
                          cy="50%"
                          innerRadius={50}
                          outerRadius={80}
                          dataKey="performance_percentage"
                          onMouseEnter={handlePieClick}
                          onMouseLeave={() => setSelectedIndex(null)}
                        >
                          {breakdown.map((entry, index) => {
                            const isSelected = selectedIndex === index;
                            return (
                              <Cell
                                key={`cell-${index}`}
                                fill={entry.color}
                                stroke={isSelected ? "white" : "none"}
                                strokeWidth={isSelected ? 3 : 0}
                                style={{
                                  outline: "none",
                                  filter: isSelected
                                    ? "drop-shadow(0px 0px 8px rgba(128, 128, 128, 0.6))"
                                    : "none",
                                  transition:
                                    "stroke-width 0.2s ease-in-out, filter 0.2s ease-in-out",
                                }}
                              />
                            );
                          })}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                      </PieChart>
                    </div>
                  )}

                  {/* Investment Details */}
                  <div className="flex flex-col space-y-2 flex-grow max-w-xs sm:max-w-md">
                    <div className="bg-[#3047EC] shadow-lg bg-opacity-20 px-4 z-[50] py-2 rounded-lg text-center md:text-left">
                      <span className="text-[10px] font-semibold">
                        TOTAL INVESTED
                      </span>
                      <span className="text-[#3047EC] text-sm font-semibold block">
                        {cardCurrencyName.symbol}
                        {totalInvestedInBreakdown
                          ? totalInvestedInBreakdown
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.00"}
                      </span>
                    </div>

                    <div className="margin-neg max-h-[300px] overflow-y-auto bg-white rounded-br-lg rounded-bl-lg rounded-tl-none rounded-tr-none shadow-lg p-2">
                      {breakdown && breakdown.length > 0 ? (
                        <div>
                          {breakdown.map((entry, index) => (
                            <div
                              key={index}
                              className="flex items-center space-x-2 py-1"
                            >
                              <span
                                className="w-3 h-3 rounded-full inline-block"
                                style={{ backgroundColor: entry.color }}
                              ></span>
                              <span
                                className="text-xs cursor-pointer overflow-hidden w-[200px] overflow-hidden text-ellipsis  leading-tight"
                                title={entry.portfolio_name} // Tooltip for full text on hover
                              >
                                Caprock Model Portfolio - {entry.portfolio_name}
                              </span>
                              <span
                                className="text-xs font-semibold"
                                style={{ color: entry.color }}
                              >
                                {entry.performance_percentage}%
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <tr>
                          <td className="text-center py-4" colSpan="7">
                            No results found
                          </td>
                        </tr>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col mt-2 p-4 bg-white rounded-lg shadow-lg">
                <h2 className="text-lg font-semibold mb-2">Recent Activity</h2>
                <div className="flex flex-wrap items-center justify-between">
                  <div className="overflow-x-auto max-h-[300px] overflow-y-auto">
                    <table className="w-full h-full  border-separate pr-1 border-[#EDEDED]  border-spacing-y-2">
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr className="shadow-md">
                          {recentactivityheader.map((header, index) => (
                            <th
                              key={header.label}
                              className={`
                       w-40   font-medium px-4 py-2 mb-5  text-left
                        ${
                          index === 0
                            ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                            : ""
                        }
                            ${
                              index === 1
                                ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                          ${
                            index === 2
                              ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                              : ""
                          }
                      `}
                            >
                              <div className="flex items-center">
                                <span>{header.label}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(3)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {recentActivityData.length > 0 ? (
                            recentActivityData.map((row, index) => (
                              <React.Fragment key={index}>
                                <tr
                                  className={` ${
                                    index % 2 === 0
                                      ? " bg-[#F5FBFF]"
                                      : " bg-white"
                                  }`}
                                >
                                  {/* First Column: Label and Details (Wider Column) */}
                                  <td className="p-2 border-t border-l border-b rounded-tl-xl rounded-bl-xl rounded-br-none rounded-br-none w-2/5">
                                    <span className="text-[#8C8C8C] text-xs block">
                                      {row.detail}
                                    </span>
                                  </td>

                                  {/* Second Column: Date */}
                                  <td className="p-2 text-black text-sm w-1/4 border-t border-b">
                                    {formatDateList(row.date)}
                                  </td>

                                  {/* Third Column: Amount (Positive: Green, Negative: Red) */}
                                  <td
                                    className={`p-2 text-sm w-1/4 border-t border-r border-b rounded-tr-xl rounded-br-xl rounded-bl-none rounded-bl-none ${
                                      row.amount < 0
                                        ? "text-[#FF5050]"
                                        : "text-[#34C046]"
                                    }`}
                                  >
                                    {row.amount > 0 ? "+" : "-"}$
                                    {Math.abs(row.amount)}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pt-4 flex mb-4 justify-between gap-4 flex-col lg:flex-row">
            <div className="lg:flex  lg:w-1/3  w-full">
              <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
                <div>
                  <Dropdown
                    label=""
                    options={performanceFilterOptions}
                    preselectedValue={preSelectedperformacefilter}
                    onSelect={handlePerformanceFilterChange}
                  />
                </div>
                <div className="">
                  {selectedperformacefilter == 1 && (
                    <div>
                      {gainers && gainers.length > 0 ? (
                        <div>
                          {gainers.map((gainer, index) => (
                            <div
                              key={index}
                              className="mt-2 border rounded-xl p-2"
                            >
                              <span className="font-semibold text-sm">
                                Caprock Model Portfolio -{" "}
                                {gainer.portfolio_name}
                              </span>
                              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-1 gap-0">
                                <div className="flex flex-col px-1">
                                  <label
                                    htmlFor="refId"
                                    className="mt-1 text-xs text-[#8C8C8C]"
                                  >
                                    Invested
                                  </label>
                                  <span className="mb-1 text-sm font-semibold text-[#3047EC]">
                                    {gainer?.invested_amount
                                      ? gainer.invested_amount
                                          .toFixed(2)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "0.00"}
                                  </span>
                                  <div className="">
                                    <label
                                      htmlFor="refId"
                                      className="mt-1 text-xs text-[#8C8C8C]"
                                    >
                                      Current
                                    </label>
                                    <span className="mb-1 text-sm font-semibold text-[#3047EC]">
                                      {gainer?.current_value
                                        ? gainer.current_value
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}
                                    </span>
                                  </div>
                                </div>
                                {/* Left column */}
                                <div className="flex  pt-0 flex-col px-1">
                                  <label
                                    htmlFor="refId"
                                    className="mt-1 text-xs text-[#8C8C8C]"
                                  >
                                    Net Gain/Year{" "}
                                    <div className="bg-[#62D76E] bg-opacity-10 ml-1 px-1 py-1 rounded-lg flex flex-col leading-none space-y-[2px]">
                                      <span className="text-[#34C046] text-xs font-semibold">
                                        {gainer.gain_percentage.toFixed(2)}%
                                      </span>
                                    </div>
                                  </label>
                                  <div className="flex items-center font-semibold text-[#34C046]">
                                    +
                                    {gainer?.net_gain_per_year
                                      ? gainer.net_gain_per_year
                                          .toFixed(2)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "0.00"}
                                    <img
                                      src="/Union.svg"
                                      alt="performance"
                                      className="ml-2"
                                    />
                                  </div>
                                  <div className="">
                                    <Line
                                      options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        elements: {
                                          line: {
                                            fill: true,
                                          },
                                        },
                                        plugins: {
                                          tooltip: {
                                            enabled: false,
                                          },
                                          legend: { display: false },
                                        },
                                        scales: {
                                          x: {
                                            grid: { display: false },
                                            ticks: { display: false },
                                            border: { display: false },
                                          },
                                          y: {
                                            grid: { display: false },
                                            ticks: { display: false },
                                            border: { display: false },
                                          },
                                        },
                                      }}
                                      data={{
                                        labels: ["Day", "Month", "Year"],
                                        datasets: [
                                          {
                                            label: "Growth",
                                            data: gainer.graph_data.map(
                                              (point) => point.value
                                            ),
                                            fill: "start",
                                            backgroundColor: (context) => {
                                              const chart = context.chart;
                                              const { ctx, chartArea } = chart;

                                              if (!chartArea) {
                                                return null; // Wait until the chart is fully rendered
                                              }

                                              const gradient =
                                                ctx.createLinearGradient(
                                                  0,
                                                  chartArea.top,
                                                  0,
                                                  chartArea.bottom
                                                );
                                              gradient.addColorStop(
                                                1,
                                                "rgba(255, 255, 255, 1)"
                                              );
                                              gradient.addColorStop(
                                                0,
                                                "rgba(52, 192, 70, 0.2)"
                                              );

                                              return gradient;
                                            },
                                            borderColor: "#34C046",
                                            borderWidth: 3,
                                            tension: 0,
                                            pointRadius: 0,
                                            shadowColor: "rgba(0, 0, 0, 0.2)",
                                            shadowBlur: 20,
                                            shadowOffsetX: 0,
                                            shadowOffsetY: 10,
                                          },
                                        ],
                                      }}
                                      plugins={[shadowPlugin]}
                                      height={50}
                                      width={200}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <tr>
                          <td className="text-center py-4" colSpan="7">
                            No results found
                          </td>
                        </tr>
                      )}
                    </div>
                  )}
                  {selectedperformacefilter == 2 && (
                    <div>
                      {losers && losers.length > 0 ? (
                        <div>
                          {losers.map((loser, index) => (
                            <div
                              key={index}
                              className="mt-2 border rounded-xl p-2"
                            >
                              <span className="font-semibold text-sm">
                                Caprock Model Portfolio - {loser.portfolio_name}
                              </span>
                              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-1 gap-0">
                                <div className="flex flex-col px-1">
                                  <label
                                    htmlFor="refId"
                                    className="mt-1 text-xs text-[#8C8C8C]"
                                  >
                                    Invested
                                  </label>
                                  <span className="mb-1 text-sm font-semibold text-[#3047EC]">
                                    {loser?.invested_amount
                                      ? loser.invested_amount
                                          .toFixed(2)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "0.00"}{" "}
                                  </span>
                                  <div className="">
                                    <label
                                      htmlFor="refId"
                                      className="mt-1 text-xs text-[#8C8C8C]"
                                    >
                                      Current
                                    </label>
                                    <span className="mb-1 text-sm font-semibold text-[#3047EC]">
                                      {loser?.current_value
                                        ? loser.current_value
                                            .toFixed(2)
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "0.00"}
                                    </span>
                                  </div>
                                </div>
                                {/* Left column */}
                                <div className="flex pt-0 flex-col px-1">
                                  <label
                                    htmlFor="refId"
                                    className="mt-1 text-xs text-[#8C8C8C]"
                                  >
                                    Net Lose/Year{" "}
                                    <div className="bg-[#ED3E31] bg-opacity-10 ml-1 px-1 py-1 rounded-lg flex flex-col leading-none space-y-[2px]">
                                      <span className="text-[#ED3E31] text-xs font-semibold">
                                        {loser.gain_percentage.toFixed(2)}%
                                      </span>
                                    </div>
                                  </label>
                                  <div className="flex items-center font-semibold text-[#ED3E31]">
                                    -
                                    {loser?.net_gain_per_year
                                      ? loser.net_gain_per_year
                                          .toFixed(2)
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "0.00"}
                                    {/* <img
                                src="/Union.svg"
                                alt="performance"
                                className="ml-2"
                              /> */}
                                  </div>
                                  <div className="">
                                    <Line
                                      options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        elements: {
                                          line: {
                                            fill: true,
                                          },
                                        },
                                        plugins: {
                                          legend: { display: false },
                                          tooltip: {
                                            enabled: false,
                                          },
                                        },
                                        scales: {
                                          x: {
                                            grid: { display: false },
                                            ticks: { display: false },
                                            border: { display: false },
                                          },
                                          y: {
                                            grid: { display: false },
                                            ticks: { display: false },
                                            border: { display: false },
                                          },
                                        },
                                      }}
                                      data={{
                                        labels: ["Day", "Month", "Year"],
                                        datasets: [
                                          {
                                            label: "Growth",
                                            data: loser.graph_data.map(
                                              (point) => point.value
                                            ),
                                            fill: "start",
                                            backgroundColor: (context) => {
                                              const chart = context.chart;
                                              const { ctx, chartArea } = chart;

                                              if (!chartArea) {
                                                return null; // Wait until the chart is fully rendered
                                              }

                                              const gradient =
                                                ctx.createLinearGradient(
                                                  0,
                                                  chartArea.top,
                                                  0,
                                                  chartArea.bottom
                                                );
                                              gradient.addColorStop(
                                                1,
                                                "rgba(255, 255, 255, 1)"
                                              );
                                              gradient.addColorStop(
                                                0,
                                                "rgba(237, 62, 49, 0.2)"
                                              );

                                              return gradient;
                                            },
                                            borderColor: "#ED3E31",
                                            borderWidth: 3,
                                            tension: 0,
                                            pointRadius: 0,
                                            shadowColor: "rgba(0, 0, 0, 0.2)",
                                            shadowBlur: 20,
                                            shadowOffsetX: 0,
                                            shadowOffsetY: 10,
                                          },
                                        ],
                                      }}
                                      plugins={[shadowPlugin]}
                                      height={50}
                                      width={200}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <tr>
                          <td className="text-center py-4" colSpan="7">
                            No results found
                          </td>
                        </tr>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full lg:w-2/3 flex">
              <div className="w-full p-4 bg-white rounded-lg shadow-lg">
                <h2 className="text-lg font-semibold mb-4">Favourites</h2>

                {/* Scrollable Container */}
                <div className="flex overflow-x-auto space-x-4 scrollbar-hide p-2">
                  {highlightData.map((data, chartIndex) => (
                    <div
                      key={chartIndex}
                      className={`flex flex-col bg-white rounded-lg  p-4 min-w-[250px] sm:min-w-[300px] md:min-w-[250px] items-center transition-all duration-200 
          ${selectedChart === chartIndex ? "shadow-2xl" : "border"}`}
                    >
                      {/* Investment Name */}
                      <h2
                        onClick={() => {
                          let redirectState = {
                            path: "/investment-details-by-id",
                            state: {
                              from: location.pathname,
                              investment_id: data.id,
                            },
                          };
                          sessionStorage.setItem(
                            "redirectAfterLogin",
                            JSON.stringify(redirectState)
                          );
                          navigate("/investment-details-by-id", {
                            state: {
                              from: location.pathname,

                              investment_id: data.id,
                            },
                          });
                        }}
                        className="text-sm font-semibold text-center underline cursor-pointer"
                      >
                        Caprock Model Portfolio - {data.name}
                      </h2>

                      {/* Pie Chart */}
                      <div className="flex justify-center w-full mt-2 relative">
                        <PieChart width={200} height={250}>
                          <Pie
                            data={data.allocations}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={80}
                            dataKey="percentage"
                            onMouseEnter={() => handleClick(chartIndex)}
                            onMouseLeave={() => {
                              setSelectedStockIndex(null);

                              setSelectedChart(null);
                              setSelectedIndexPerformance(null);
                            }}
                            onTouchStart={() => handleClick(chartIndex)}
                            onTouchEnd={() => {
                              setSelectedStockIndex(null);

                              setSelectedChart(null);
                              setSelectedIndexPerformance(null);
                            }}
                          >
                            {data.allocations.map((entry, index) => {
                              const isSelected =
                                selectedChart === chartIndex &&
                                selectedIndexPerformance === index;
                              return (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={"#" + entry.color_code}
                                  stroke={isSelected ? "white" : "none"}
                                  strokeWidth={isSelected ? 3 : 0}
                                  className="pie-cell cursor-pointer transition-all duration-200"
                                  style={{
                                    outline: "none",
                                    filter: isSelected
                                      ? "drop-shadow(0px 0px 8px rgba(128, 128, 128, 0.6))"
                                      : "",
                                  }}
                                  onMouseEnter={() =>
                                    setSelectedStockIndex(index)
                                  }
                                  onMouseLeave={() =>
                                    setSelectedStockIndex(null)
                                  }
                                  onTouchStart={() =>
                                    setSelectedStockIndex(index)
                                  }
                                  onTouchEnd={() => setSelectedStockIndex(null)}
                                />
                              );
                            })}
                          </Pie>
                          {selectedChart === chartIndex && (
                            <Tooltip content={<CustomTooltip />} />
                          )}
                          {/* 🔥 Centered Text */}
                          <text
                            x="50%"
                            y="50%"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fontSize="18"
                            fontWeight="bold"
                            fill="black"
                          >
                            <tspan
                              fill="#34C046"
                              fontSize="20"
                              fontWeight="bold"
                            >
                              {data.annual_growth >= 0 ? "+" : "-"}
                              {Math.abs(data.annual_growth.toFixed(2))}
                            </tspan>
                            <tspan x="50%" dy="20" fill="#8C8C8C" fontSize="10">
                              Yearly Return
                            </tspan>
                          </text>
                        </PieChart>
                      </div>

                      {/* Investment Details */}
                      <div className="mt-3 w-full">
                        {data.allocations.map((entry, idx) => {
                          const isSelectedStock =
                            selectedChart === chartIndex &&
                            selectedIndexPerformance !== null &&
                            entry.color_code ===
                              data.allocations[selectedIndexPerformance]
                                ?.color_code;
                          return (
                            <div
                              key={idx}
                              style={{
                                opacity:
                                  selectedIndexPerformance === null ||
                                  isSelectedStock
                                    ? 1
                                    : 0.5,
                              }}
                              className="flex justify-between items-center space-x-2 py-1 transition-all"
                            >
                              <div className="flex items-center space-x-2">
                                <span
                                  className="w-3 h-3 rounded-full"
                                  style={{
                                    backgroundColor: "#" + entry.color_code,
                                  }}
                                ></span>
                                <span
                                  className={`text-xs transition-all duration-200 ${
                                    isSelectedStock ? "font-semibold" : ""
                                  }`}
                                  style={{
                                    color: "black",
                                  }} // Change text color on click
                                >
                                  {entry.name}
                                </span>
                              </div>
                              <span
                                className="text-xs font-semibold"
                                style={{ color: "#" + entry.color_code }}
                              >
                                {entry.percentage}%
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {defaultCard.id == 3 && <InvestmentList />}
    </div>
  );
};

export default DashboardDetails;
